// import React, { useEffect, useState } from 'react';
// import { Link } from 'react-router-dom';
// import { motion } from 'framer-motion';
// import axios from 'axios';
// import { BsCheckLg } from 'react-icons/bs';
// import { HiArrowLongRight } from 'react-icons/hi2';
// import TopBar from '../components/TopBar';
// import Header from '../components/headerfooter/Header';
// import Footer from '../components/headerfooter/Footer';
// import MobileFooter from '../components/MobileFooter';
// import HeroBanner from '../components/home/HeroBanner';
// import JustLaunched from '../components/home/JustLaunched';
// import CallToAction from '../components/home/CallToAction';
// import Loader from '../components/Loader';
// import { ChevronDown } from "lucide-react";
// import { IoChevronDownSharp } from "react-icons/io5";
// import { FaQuoteLeft } from "react-icons/fa";
// import { FaCheck, FaTimes } from "react-icons/fa";
// import { Swiper, SwiperSlide } from 'swiper/react';
// import 'swiper/css';
// import { REACT_APP_API_PORT } from '../Api';
// import { NavLink } from "react-router-dom";
// import { GiCheckMark } from "react-icons/gi";
// import { FaInstagram, FaYoutube, FaUsers, FaEye } from "react-icons/fa";


// const fadeUp = {
//   hidden: { opacity: 0, y: 30 },
//   visible: {
//     opacity: 1,
//     y: 0,
//     transition: { duration: 0.6, ease: 'easeOut' },
//   },
// };

// function highlightMultipleKeywords(text, keywords) {
//   const regex = new RegExp(`(${keywords.join("|")})`, "gi");
//   const parts = text.split(regex);

//   return parts.map((part, index) =>
//     keywords.includes(part) ? (
//       <span
//         key={index}
//         className="bg-gradient-to-r from-[#ffffff] via-[#f55fff] to-[#0047FF] bg-clip-text text-transparent"
//       >
//         {part}
//       </span>
//     ) : (
//       <React.Fragment key={index}>{part}</React.Fragment>
//     )
//   );
// }

// const plansData = [
//   {
//     title: "🧑‍💻 AI Basic (Kickstart with AI)",
//     subtitle: "For Students Starting with AI",
//     isPopular: "No",
//     plans: ["Monthly", "Quarterly", "Yearly"],
//     monthly_selling_price: 199,
//     monthly_original_price: 349,
//     monthly_discount: 43,
//     quarterly_selling_price: 597,
//     quarterly_original_price: 1050,
//     quarterly_discount: 43,
//     yearly_selling_price: 1990,
//     yearly_original_price: 4200,
//     yearly_discount: 53,
//     monthly_subscription_link: "#",
//     quarterly_subscription_link: "#",
//     yearly_subscription_link: "#",
//     subscription_button_name: "Buy Now",
//     features_heading_monthly: "Essential features to start",
//     features_heading_quarterly: "Essential features to start",
//     features_heading_yearly: "Essential features to start",
//     features: [
//       "100+ Premium Video Prompts",
//       "500+ Expert Image Prompts",
//       "100+ Downloadable AI Guides",
//       "Private Community Access",
//       "Fresh Content Every Week"
//     ]
//   },
//   {
//     title: "👑 AI Premium (Earn with AI)",
//     subtitle: "For Mastering AI & Earning Big",
//     isPopular: "Yes",
//     plans: ["Monthly", "Quarterly", "Yearly"],
//     monthly_selling_price: 999,
//     monthly_original_price: 1999,
//     monthly_discount: 50,
//     quarterly_selling_price: 2997,
//     quarterly_original_price: 5997,
//     quarterly_discount: 50,
//     yearly_selling_price: 9990,
//     yearly_original_price: 23988,
//     yearly_discount: 58,
//     monthly_subscription_link: "#",
//     quarterly_subscription_link: "#",
//     yearly_subscription_link: "#",
//     subscription_button_name: "Buy Now",
//     features_heading_monthly: "Everything in Start, plus",
//     features_heading_quarterly: "Everything in Start, plus",
//     features_heading_yearly: "Everything in Start, plus",
//     features: [
//       "Unlimited Video + Image Prompts",
//       "Early Access to All Courses",
//       "Monthly Live Q&A / AMA with Satyam",
//       "Private WhatsApp Community",
//       "1 Free 1:1 Strategy Call (Quarterly)",
//       "Access to Guest Workshops",
//       "All Pro Plan Features"
//     ]
//   },
//   {
//     title: "🚀 AI Pro (Grow with AI)",
//     subtitle: "For Hustlers Ready to Scale with AI",
//     isPopular: "No",
//     plans: ["Monthly", "Quarterly", "Yearly"],
//     monthly_selling_price: 349,
//     monthly_original_price: 500,
//     monthly_discount: 30,
//     quarterly_selling_price: 1047,
//     quarterly_original_price: 1500,
//     quarterly_discount: 30,
//     yearly_selling_price: 3489,
//     yearly_original_price: 6000,
//     yearly_discount: 42,
//     monthly_subscription_link: "#",
//     quarterly_subscription_link: "#",
//     yearly_subscription_link: "#",
//     subscription_button_name: "Buy Now",
//     features_heading_monthly: "Everything in Basic, plus",
//     features_heading_quarterly: "Everything in Basic, plus",
//     features_heading_yearly: "Everything in Basic, plus",
//     features: [
//       "250+ Premium Video Prompts",
//       "All Basic Plan Features",
//       "Priority Access to New Tools",
//       "Exclusive AI Tools & Challenges",
//       "1 Free AI Course Module"
//     ]
//   }
// ];

// const features = [
//   {
//   title: "Explore the Ultimate Prompt Library",
//   subtitle: "Features 2",
//   description:
//     "Discover a wide collection of AI prompts to supercharge your creativity, productivity, and workflow. Ideal for marketers, writers, developers, and more.",
//   list: [
//     "Daily updates on major AI advancements",
//     "Stay informed on tools, trends, and best practices",
//     "Visual and concise summaries for quick reading",
//   ],
//   buttonText: "Request A Demo",
//   buttonLink: "/login",
//   image: "/images/sec2.webp",
//   reverse: true,
// },
//   {
//   title: "AI Courses That Level You Up",
//   subtitle: "Features 1",
//   description:
//     "Master AI tools and technologies with our expertly crafted courses. Learn at your own pace and gain practical skills to apply AI in real-world projects and businesses.",
//   list: [
//     "Hands-on courses covering top AI tools and use cases",
//     "Learn how to apply AI to real-world problems",
//     "Visual guides and video lessons to enhance learning",
//   ],
//   buttonText: "Get Started Free",
//   buttonLink: "/login",
//   image: "/images/sec1.webp",
//   reverse: false,
// },

//   {
//   title: "Latest in AI News",
//   subtitle: "Features 3",
//   description:
//     "Stay ahead in the AI world with curated news, trends, and updates. Get insights into the latest AI breakthroughs, research, tools, and industry movements.",
//   list: [
//     "Daily updates on major AI advancements",
//     "Stay informed on tools, trends, and best practices",
//     "Visual and concise summaries for quick reading",
//   ],
//   buttonText: "Get Started Free",
//   buttonLink: "/login",
//   image: "/images/sec3.webp",
//   reverse: false,
// },
// ];

// const faqs = [
//   {
//     question: "What is NextFutureAI and how does it work?",
//     answer:
//       "NextFutureAI is an online platform for creator educators that allows you to create, market, and sell courses, communities, memberships, digital downloads, coaching, webinars, and other digital products.\n\nYou can easily sell to both consumers and other businesses (B2B and B2C) using intuitive, easy-to-use tools and AI assistance.",
//   },
//   {
//     question: "Is it easy to get started?",
//     answer:
//       "NextFutureAI is an online platform for creator educators that allows you to create, market, and sell courses, communities, memberships, digital downloads, coaching, webinars, and other digital products.\n\nYou can easily sell to both consumers and other businesses (B2B and B2C) using intuitive, easy-to-use tools and AI assistance.",
//   },
//   {
//     question: "Can I cancel or change my account at any time?",
//     answer:
//       "NextFutureAI is an online platform for creator educators that allows you to create, market, and sell courses, communities, memberships, digital downloads, coaching, webinars, and other digital products.\n\nYou can easily sell to both consumers and other businesses (B2B and B2C) using intuitive, easy-to-use tools and AI assistance.",
//   },
//   {
//     question: "I already have a website. Can I integrate it with NextFutureAI?",
//     answer:
//       "NextFutureAI is an online platform for creator educators that allows you to create, market, and sell courses, communities, memberships, digital downloads, coaching, webinars, and other digital products.\n\nYou can easily sell to both consumers and other businesses (B2B and B2C) using intuitive, easy-to-use tools and AI assistance.",
//   },
//   {
//     question: "Do I need a separate web hosting?",
//     answer:
//       "NextFutureAI is an online platform for creator educators that allows you to create, market, and sell courses, communities, memberships, digital downloads, coaching, webinars, and other digital products.\n\nYou can easily sell to both consumers and other businesses (B2B and B2C) using intuitive, easy-to-use tools and AI assistance.",
//   },
//   {
//     question: "Does NextFutureAI have a marketplace?",
//     answer:
//       "NextFutureAI is an online platform for creator educators that allows you to create, market, and sell courses, communities, memberships, digital downloads, coaching, webinars, and other digital products.\n\nYou can easily sell to both consumers and other businesses (B2B and B2C) using intuitive, easy-to-use tools and AI assistance.",
//   },
//   // Add more FAQs as needed
// ];

// const testimonials = [
//     {
//       text: `"I run a digital marketing agency and found this course through Instagram ads. The storytelling segment and process-oriented approach were valuable, but I’d rate it 8.5/10, as the Instagram course could include more on branding and business."`,
//       name: "Pratik",
//       course: "Video Editing Course",
//       icon: "https://cdn.prod.website-files.com/65f02985a70b38d810964d03/679c6e21bd94aef22a77beb5_Icon%20Strategy%20(10).svg",
//     },
//     {
//       text: `"Highly informative and helpful, especially for a beginner like me. The art of conversation and outreach segments were the most beneficial. I’d recommend this course to anyone pursuing podcasting and would rate it 8.5/10."`,
//       name: "Abhay Maheshwari",
//       course: "Podcasting 101",
//       icon: "https://cdn.prod.website-files.com/65f02985a70b38d810964d03/679c6e224dd18feef88a0801_Icon%20Strategy%20(15).svg",
//     },
//     {
//       text: `"I found this course through Instagram ads, and the monetizing strategies were really insightful. While I would have loved more in-depth content on Meta and Instagram monetization, I’d still rate the course 9.5/10 for its value and help!"`,
//       name: "Shubham Shinde",
//       course: "Monetising Content creation",
//       icon: "https://cdn.prod.website-files.com/65f02985a70b38d810964d03/679c6e22cfa7a1910d852790_Icon%20Strategy%20(17).svg",
//     },
//     {
//       text: `"I’m a 42-year-old jewelry business owner in Bengaluru, and I took this course to learn about Instagram for my business. I really enjoyed the course, especially the insights on AI and prompt engineering, though I wish it was a bit longer. I’d rate it 8/10 and have recommended it to friends!"`,
//       name: "Jhansi Upputuri",
//       course: "Instagram 101",
//       icon: "https://cdn.prod.website-files.com/65f02985a70b38d810964d03/6799ddd30ce470e2148d53f8_Icon%20Strategy%20(11).svg",
//     },
//     {
//       text: `"I'm a photographer and video editor who discovered your course through The Ranveer Show and Instagram. It taught me valuable new skills, though more detailed breakdowns of complex techniques would enhance it—9/10 overall!"`,
//       name: "Shreya Yadav",
//       course: "Video Editing Course",
//       icon: "https://cdn.prod.website-files.com/65f02985a70b38d810964d03/679c6e21406c4123d2680bee_Icon%20Strategy%20(2).svg",
//     },
//     {
//       text: `"As a beginner, I found this course incredibly helpful, learning many new insights and detailed knowledge. I'm starting a solo podcast and plan to apply these learnings. As a big fan of Ranveer, I’d rate it 10/10 and highly recommend it."`,
//       name: "Apprna Walia",
//       course: "Podcasting 101",
//       icon: "https://cdn.prod.website-files.com/65f02985a70b38d810964d03/679c6e2248e62cb35887ed81_Icon%20Strategy%20(12).svg",
//     },
//     {
//       text: `"I discovered this course through Facebook and Instagram, and it served as a great refresher with insightful content and excellent mentors. Despite a minor app issue, I found the course perfect for launching my social media channel, and I’d rate it 10/10."`,
//       name: "Pradnya Shinde",
//       course: "Monetising Content creation",
//       icon: "https://cdn.prod.website-files.com/65f02985a70b38d810964d03/679c6e21001cc3a4c10f5012_Icon%20Strategy%20(3).svg",
//     },
//     {
//       text: `"I bought the course out of curiosity, and I'm glad I did! I'm pursuing a postgraduate degree in Architecture, and I found the course insightful, especially the first five modules. Although the later modules felt repetitive, they were still necessary. I'd recommend this course to anyone looking to improve their Instagram game and have already suggested it to a few friends. I'd rate it 8/10."`,
//       name: "Sipun Naik",
//       course: "Instagram 101",
//       icon: "https://cdn.prod.website-files.com/65f02985a70b38d810964d03/679c6e227d9046f26ed8d436_Icon%20Strategy%20(5).svg",
//     },
//     {
//       text: `"I run a chocolate business and took this course to learn reel editing. The mentors explained everything clearly, though I faced challenges with raw footage access and lack of software—overall a great course, but I’ll rate it fully after completing it."`,
//       name: "Deepali Bahadur",
//       course: "Video Editing Course",
//       icon: "https://cdn.prod.website-files.com/65f02985a70b38d810964d03/679c6e23fc527c2e490b586a_Icon%20Strategy%20(9).svg",
//     },
//   ];

//   const courses = [
//   {
//     title: 'AI 3D Cartoon Animation Video Course',
//     price: '₹350',
//     img: '/images/course1.png',
//     link: 'https://tr.ee/yhvSpN',
//   },
//   {
//     title: 'AI Miniature Video Course',
//     price: '₹199',
//     img: '/images/course2.png',
//     link: 'https://satyamai.rpy.club/course/wz2za35EOP',
//   },
//   {
//     title: 'CGI Ads Mastery with AI - Course',
//     price: '₹349',
//     oldPrice: '₹1999',
//     img: '/images/course3.png',
//     link: 'https://satyamai.rpy.club/course/4BxvYpdHNV',
//   },
//   {
//     title: 'Viral AI Ads & Branding Masterclass with ChatGPT',
//     price: '₹599',
//     img: '/images/course4.png',
//     link: 'https://tr.ee/Ftb1XX',
//   },
// ];

// const videoTestimonials = [
//   { url: "https://www.youtube.com/embed/LNLUypwL0aU?si=M7gQ3k8OmvEMOAn5" },
//   { url: "https://www.youtube.com/embed/_6WVxRNM8MA?si=U1bUhaA-xW2c673c" },
//   { url: "https://www.youtube.com/embed/Byz8XoyS8Lo?si=_6lzz2IgCiuxPEN1" },
//   { url: "https://www.youtube.com/embed/LNLUypwL0aU?si=M7gQ3k8OmvEMOAn5" },
//   { url: "https://www.youtube.com/embed/_6WVxRNM8MA?si=U1bUhaA-xW2c673c" },
//   { url: "https://www.youtube.com/embed/Byz8XoyS8Lo?si=_6lzz2IgCiuxPEN1" },
// ];

// const Home2 = () => {
//   const [isLoading, setIsLoading] = useState(false);
//   const [data, setData] = useState([]);
//   const [additionalData, setadditionalData] = useState([]);

//   const [showAll, setShowAll] = useState(false);

//   const fetchData = async () => {
//     try {
//       setIsLoading(true);
//       const res = await axios.get(
//         `${REACT_APP_API_PORT}user/homepage/nextfutureai_homepage_details`
//       );
//       if (res.data.status){
//         setData(res.data.data)
//         if(res.data.additionalData){
//           setadditionalData(res.data.additionalData)
//         }
//       }
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const [openIndex, setOpenIndex] = useState(null);

//   const toggleAccordion = (index) => {
//     setOpenIndex(openIndex === index ? null : index);
//   };

//   const toggleFAQ = (index) => {
//     setOpenIndex(openIndex === index ? null : index);
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);


//     const [planType, setPlanType] = useState("Monthly");
//   const discount = { discount: "Best Value" };

//     const stats = [
//     {
//       icon: <FaInstagram className="text-pink-500 w-8 h-8" />,
//       value: data?.section1_instagram_followers,
//       label: "Followers",
//     },
//     {
//       icon: <FaYoutube className="text-red-500 w-8 h-8" />,
//       value: data?.section1_youtube_subscribers,
//       label: "Subscribers",
//     },
//     {
//       icon: <FaUsers className="text-blue-500 w-8 h-8" />,
//       value: data?.section1_members,
//       label: "Members",
//     },
//     {
//       icon: <FaEye className="text-green-500 w-8 h-8" />,
//       value:data?.section1_views,
//       label: "Views",
//     },
//   ];

//    const HtmlContent = ({ content }) => {
//   return <div dangerouslySetInnerHTML={{ __html: content }} />;
// };

//   return (
//     <>
//       <Loader isLoading={isLoading} />
//       {/* <TopBar /> */}
//       <Header />
//       {/* <HeroBanner /> */}
//        <section className="relative overflow-hidden bg-background-back1 text-white pb-20 pt-[120px] lg:pb-[50px] lg:pt-[140px] font-sans">
//         {/* 🔥 Gradient Glow Backgrounds */}
//         <div className="pointer-events-none absolute inset-0 z-0">
//           {/* Blue Glow Left */}
//           <div className="absolute top-[-150px] left-[-100px] h-[600px] w-[600px] bg-[radial-gradient(circle,rgba(0,102,255,0.5)_0%,transparent_70%)] blur-[120px]"></div>

//           {/* Purple-Pink Glow Right */}
//           <div className="absolute bottom-[-100px] right-[-100px] h-[500px] w-[500px] bg-[radial-gradient(circle,rgba(28,0,225,0.90)_0%,transparent_70%)] blur-[100px]"></div>

//           {/* Greenish Cyan Glow Center-Left */}
//           <div className="absolute bottom-[10%] left-[25%] h-[300px] w-[300px] bg-[radial-gradient(circle,rgba(0,255,171,0.4)_0%,transparent_70%)] blur-[90px]"></div>
//         </div>

//         {/* Main Content */}
//         <div className="relative z-10 mx-auto max-w-7xl px-6 sm:px-8 lg:px-12">
//           <div className="flex flex-col items-center text-center gap-6 md:gap-6">
//             {/* Heading Section */}
//             <motion.h1 className="text-[45px] font-extrabold leading-tight tracking-tight lg:text-[80px]"
//             variants={fadeUp}
//                 initial="hidden"
//                 whileInView="visible"
//                 viewport={{ once: true }}
//                 data-aos="fade-up-sm"
//                 data-aos-delay={100} >
//               {data?.section1_heading}&nbsp;
//               <span className="bg-gradient-to-r from-[#ffffff] via-[#f55fff] to-[#0047FF] bg-clip-text text-transparent drop-shadow-lg">
//                 {data?.section1_heading2}
//               </span>
//             </motion.h1>

//             <motion.p className="mt-0 md:mt-4 max-w-5xl text-lg leading-relaxed text-gray-300 max-w-[700px] sm:text-xl lg:text-[28px]"
//             variants={fadeUp}
//                 initial="hidden"
//                 whileInView="visible"
//                 viewport={{ once: true }}
//                 data-aos="fade-up-sm"
//                 data-aos-delay={200}>
//               <HtmlContent content={data?.section1_description} />
//             </motion.p>

//             {/* CTA Buttons */}
//             <motion.div className="flex flex-wrap justify-center gap-6 mt-5"
//             variants={fadeUp}
//                 initial="hidden"
//                 whileInView="visible"
//                 viewport={{ once: true }}
//                 data-aos="fade-up-sm"
//                 data-aos-delay={300}>
//               {data?.section1_button_name && (
//                 <Link to={data?.section1_button_link}>
//                   <button
//                     className="block md:w-auto w-full text-center px-10 text-[18px] py-5 rounded text-white transition-transform hover:scale-105 font-semibold bg-gradient-to-r from-[#ffffff] via-[#f55fff] to-[#0047FF] hover:from-[#0057e6] hover:to-[#00b2e6] transition-all duration-300 shadow-lg"
//                     type="button"
//                   >
//                     {data?.section1_button_name}
//                   </button>
//                 </Link>
//               )}

//               {data?.section1_button2_name && (
//                 <Link to={data?.section1_button2_link}>
//                   <button
//                     className="rounded px-10 text-[18px] py-5 text-white font-semibold transition-transform hover:scale-105 hover:text-white hover:bg-gradient-to-r from-[#ffffff] via-[#f55fff] to-[#0047FF] hover:from-[#0057e6] hover:to-[#00b2e6] border-2 border-customBlue focus:ring-4 focus:ring-gray-500 duration-200 shadow-lg"
//                     type="button"
//                   >
//                     {data?.section1_button2_name}
//                   </button>
//                 </Link>
//               )}
//             </motion.div>
//           </div>
//           <section className="relative py-12">
//               {/* Optional: Subtle blurred background glow */}


//               <div className="relative max-w-6xl mx-auto px-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 z-10">
//                 {stats.map((stat, index) => (
//                   <div
//                     key={index}
//                     className={`flex flex-col items-center bg-white/5 rounded-2xl p-6 shadow-xl 
//                     hover:shadow-[0_0_25px_#000] transition-all duration-300 group`}
//                   >
//                     <div className="mb-4 transition-transform duration-300 group-hover:scale-110">
//                       {stat.icon}
//                     </div>
//                     <h3 className="text-2xl font-bold text-white">{stat.value}</h3>
//                     <p className="text-gray-400">{stat.label}</p>
//                   </div>
//                 ))}
//               </div>
//             </section>
//         </div>
//       </section>
//       <section className="relative bg-black py-12">
//         <h2 className="text-4xl md:text-5xl text-center mb-8 font-extrabold text-white tracking-tight">
//             {data?.section2_heading} 
//             <span className="text-transparent mx-3  bg-clip-text bg-gradient-to-r from-[#ffffff] via-[#f55fff] to-[#0047FF]">
//              {data?.section2_heading2}
//             </span>
//            <br></br>{data?.section2_heading3}
//           </h2>
//         {/* Optional: Subtle blurred background glow */}
//         <div className="absolute inset-0 pointer-events-none">
//           <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-[#0001ff] opacity-30 blur-[180px] rounded-full"></div>
//         </div>

//         <div className="relative max-w-6xl mx-auto px-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 z-10">
//           {stats.map((stat, index) => (
//             <div
//               key={index}
//               className={`flex flex-col items-center bg-white/5 rounded-2xl p-6 shadow-xl 
//               hover:shadow-[0_0_25px] transition-all duration-300 group`}
//             >
//               <div className="mb-4 transition-transform duration-300 group-hover:scale-110">
//                 {stat.icon}
//               </div>
//               <h3 className="text-2xl font-bold text-white">{stat.value}</h3>
//               <p className="text-gray-400">{stat.label}</p>
//             </div>
//           ))}
//         </div>
//       </section>


//       <div>
//         {/* Overlay */}

//       {/* <JustLaunched setisLoading={setIsLoading} /> */}

//       <section className="relative py-24 bg-black text-white overflow-visible">
//   {/* Glow Effects */}
//   <div className="pointer-events-none absolute inset-0 z-0 overflow-hidden">
//     <div
//       className="absolute -top-[0px] -left-[300px] w-[1000px] h-[1000px] rounded-full blur-[220px] opacity-60 animate-pulse-glow"
//       style={{
//         background: "radial-gradient(circle at center, rgba(0, 8, 255, 0.86), transparent 70%)",
//       }}
//     />
//     <div
//       className="absolute -bottom-[300px] -right-[300px] w-[900px] h-[900px] rounded-full blur-[200px] opacity-60 animate-pulse-glow"
//       style={{
//         background: "radial-gradient(circle at center, rgba(0, 102, 255, 0.81), transparent 70%)",
//       }}
//     />
//   </div>

//       {/* Main Content */}
//       <div className="relative z-10 max-w-[90rem] mx-auto px-4">
//         {/* Title */}
//         <motion.h2
//           className="text-center text-[40px] lg:text-[50px] font-extrabold tracking-tight leading-tight whitespace-nowrap"
//           variants={fadeUp}
//           initial="hidden"
//           whileInView="visible"
//           viewport={{ once: true }}
//         >
//           Our Latest
//           <span className="ml-3 bg-gradient-to-r from-[#ffffff] via-[#f55fff] to-[#0047FF] bg-clip-text text-transparent drop-shadow-lg">
//             AI Course
//           </span>
//         </motion.h2>

//         {/* Swiper Cards */}
//         <Swiper
//   slidesPerView={3}
//   spaceBetween={24}
//   className="px-2"
//   breakpoints={{
//     320: { slidesPerView: 1.1 },
//     640: { slidesPerView: 2.1 },
//     1024: { slidesPerView: 3.1 },
//   }}
// >
//   {courses.map((c, i) => (
//     <SwiperSlide key={i} className='pt-[42px] pb-[42px]'>
//       <motion.div
//         whileInView={{ opacity: 1, y: 0 }}
//         initial={{ opacity: 0, y: 40 }}
//         transition={{ delay: i * 0.1, duration: 0.5, ease: "easeOut" }}
//       >
//         <div className="group flex flex-col bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl overflow-hidden shadow-2xl transition-transform duration-300 hover:scale-[1.03] hover:shadow-[0_0_50px_rgba(0,198,255,0.25)]">
//           <img
//             src={c.img}
//             alt={c.title}
//             className="w-full h-60 object-cover rounded-t-2xl"
//           />
//           <div className="p-6 flex flex-col justify-between flex-grow space-y-5">
//             {/* Title - Large, Bold, Single Line */}
//             <h3 className="text-2xl font-bold text-white truncate group-hover:text-[#00C6FF] transition duration-300">
//               {c.title}
//             </h3>

//             {/* Description */}
//             <p className="text-base text-gray-300 leading-relaxed line-clamp-3">
//               {c.description || (
//                 <span className="italic text-gray-400">
//                   Unlock the full potential of AI for content, storytelling, and creativity.
//                 </span>
//               )}
//             </p>

//             {/* Price Section */}
//             <div className="flex items-center gap-4 mt-auto">
//               <span className="text-2xl font-bold text-white">
//                 {c.price}
//               </span>
//               {c.oldPrice && (
//                 <span className="text-lg text-gray-400 line-through">
//                   {c.oldPrice}
//                 </span>
//               )}
//             </div>

//             {/* CTA Button */}
//             <a
//               href={c.link}
//               target="_blank"
//               rel="noopener noreferrer"
//               className="inline-block w-full text-center px-5 py-3 rounded-lg font-semibold text-white text-lg bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)] hover:bg-[linear-gradient(45deg,#ff7a18,#ff0066,#9b30ff,#3a7bd5)] transition-all duration-300 shadow-lg"
//             >
//               Enroll Now
//             </a>
//           </div>
//         </div>
//       </motion.div>
//     </SwiperSlide>
//   ))}
// </Swiper>

//       </div>
//     </section>

//       <section className="relative overflow-hidden bg-black py-24">
//       {/* Multicolor Background Glows */}
//       <div className="pointer-events-none absolute inset-0 z-0 overflow-hidden">
//         {/* Top Glow */}
//         <div
//           className="absolute -top-[200px] left-[0px] -translate-x-1/2 w-[900px] h-[900px] rounded-full blur-[220px] opacity-70"
//           style={{
//             background:
//               "radial-gradient(circle at center, rgba(0, 102, 255, 0.75), transparent 80%)",
//           }}
//         />
//         {/* Middle Glow */}
//         <div
//           className="absolute top-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[1000px] rounded-full blur-[240px] opacity-70"
//           style={{
//             right: "-80%",
//             background:
//               "radial-gradient(circle at center, rgba(0, 85, 255, 0.6), transparent 85%)",
//           }}
//         />
//         {/* Bottom Glow */}
//         <div
//           className="absolute bottom-[100px] left-1/2 -translate-x-1/2 w-[1000px] h-[1000px] rounded-full blur-[200px] opacity-70"
//           style={{
//             background:
//               "radial-gradient(circle at center, rgba(0, 128, 255, 0.7), transparent 80%)",
//           }}
//         />
//       </div>

//       {/* Feature Cards */}
//       <div className="relative z-10 container max-w-[80rem] mx-auto px-4 space-y-24">
//         {features.map((feature, index) => {
//           const isMiddleBox = index === 1;

//           return (
//             <div
//               key={index}
//               className="relative flex flex-col lg:flex-row items-center gap-10 p-1 rounded-[32px]"
//             >
//               {/* Glow behind card */}
//               <div className="absolute inset-0 rounded-[32px] bg-gradient-to-br from-[#00C6FF66] via-[#FF00F733] to-[#00FFAA66] blur-[100px] z-0 opacity-40" />

//               {/* Glass Card */}
//               <div className="relative z-10 w-full bg-white/5 backdrop-blur-2xl border border-white/10 rounded-[32px] p-6 md:p-14">
//                 <div
//                   className={`flex flex-col lg:flex-row items-center gap-10 ${
//                     isMiddleBox ? "lg:flex-row-reverse" : ""
//                   }`}
//                 >
//                   {/* Image */}
//                   <div className="lg:w-1/2">
//                     <img
//                       src={feature.image}
//                       alt={feature.title}
//                       className="w-full h-auto rounded-2xl shadow-xl"
//                     />
//                   </div>

//                   {/* Text */}
//                   <div className="lg:w-1/2 space-y-6">
//                     <h2 className="text-[30px] md:text-[50px] leading-[56px] font-extrabold text-white drop-shadow-lg">
//                       {highlightMultipleKeywords(feature.title, ["Prompt Library", "AI Courses", "AI News"])}
//                     </h2>

//                     <p className="text-gray-300 text-lg">{feature.description}</p>

//                     {feature.list && (
//                       <ul className="space-y-3 pt-2">
//                         {feature.list.map((item, i) => (
//                           <li
//                             key={i}
//                             className="flex items-start gap-3 text-white text-base"
//                           >
//                             <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#0069ff] bg-opacity-20">
//                               <BsCheckLg className="text-[#00FFD1] text-lg" />
//                             </div>
//                             <span>{item}</span>
//                           </li>
//                         ))}
//                       </ul>
//                     )}

//                     <Link
//                       to={feature.buttonLink}
//                       className="inline-flex items-center gap-2 mt-6 px-6 py-3 text-lg font-semibold bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)] hover:bg-[linear-gradient(45deg,#ff7a18,#ff0066,#9b30ff,#3a7bd5)] text-white rounded-xl shadow-lg transition duration-300 hover:scale-105"
//                     >
//                       {feature.buttonText}
//                       <HiArrowLongRight className="text-xl" />
//                     </Link>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           );
//         })}
//       </div>
//     </section>


//     <div className="relative bg-black pb-4 pt-16 overflow-hidden">
//       {/* Multicolor Glow Backgrounds */}
//       <div className="pointer-events-none absolute inset-0 z-0">
//         <div className="absolute top-[-200px] left-[-200px] w-[500px] h-[500px] rounded-full bg-[#0026ff] opacity-50 blur-[200px]" />
//         <div className="absolute bottom-[-250px] right-[-150px] w-[600px] h-[600px] rounded-full bg-[#FF00C7] opacity-20 blur-[200px]" />
//         <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] rounded-full bg-[#7F00FF] opacity-10 blur-[250px]" />
//       </div>

//       {/* Foreground Content */}
//       <div className="relative z-10">
//         <div className="max-w-[90rem] mx-auto text-center mb-2 px-4">
//           <h2 className="text-4xl md:text-5xl font-extrabold text-white tracking-tight">
//             Unlock All with{" "}
//             <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#ffffff] via-[#f55fff] to-[#0047FF]">
//               One Membership
//             </span>
//           </h2>
//           <p className="text-gray-400 mt-4 max-w-2xl mx-auto text-lg leading-relaxed">
//             Access all AI courses, 1000+ prompts, viral video tutorials & expert
//             support — in one powerful plan.
//           </p>
//         </div>

//         <div className="flex justify-center mb-10 pt-10">
//           {["Monthly", "Quarterly", "Yearly"].map((type) => (
//             <button
//               key={type}
//               onClick={() => setPlanType(type)}
//               className={`px-4 py-2 mx-2 rounded-lg font-semibold transition flex items-center gap-2 border border-gray-600 ${
//                 planType === type
//                   ? "bg-gradient-to-r from-[#ffffff] via-[#f55fff] to-[#0047FF] text-white shadow-lg"
//                   : "bg-[#2c2c2c] text-white hover:bg-gray-700"
//               }`}
//             >
//               {type}
//             </button>
//           ))}
//         </div>

//         <div className="max-w-[90rem] mx-auto px-4 pb-14 pt-5 grid md:grid-cols-2 lg:grid-cols-3 gap-10 place-items-center">
//           {plansData.map((plan, index) => {
//             const priceMap = {
//               Monthly: [
//                 plan.monthly_selling_price,
//                 plan.monthly_original_price,
//                 plan.monthly_discount,
//                 plan.monthly_subscription_link,
//                 plan.features_heading_monthly,
//               ],
//               Quarterly: [
//                 plan.quarterly_selling_price,
//                 plan.quarterly_original_price,
//                 plan.quarterly_discount,
//                 plan.quarterly_subscription_link,
//                 plan.features_heading_quarterly,
//               ],
//               Yearly: [
//                 plan.yearly_selling_price,
//                 plan.yearly_original_price,
//                 plan.yearly_discount,
//                 plan.yearly_subscription_link,
//                 plan.features_heading_yearly,
//               ],
//             };

//             const [selling, original, discount, link, heading] = priceMap[planType];

//             const card = (
//               <div className="relative flex flex-col h-full rounded-2xl p-8 bg-black/40 border border-gray-700 shadow-[0_0_40px_rgba(0,170,255,0.15)] transition-transform hover:scale-[1.02] backdrop-blur-md text-center">
//                 <h2 className="text-xl font-bold text-white mb-2">{plan.title}</h2>
//                 <p className="text-white mb-4 text-md max-w-[450px] mx-auto">
//                   {plan.short_description}
//                 </p>

//                 <div className="mb-4">
//                   <span className="text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-[#ffffff] via-[#f55fff] to-[#0047FF] drop-shadow-md">
//                     ₹{selling} <span className="text-xl text-white">/{planType.slice(0, 2)}</span>
//                   </span>
//                   <br />
//                   <span className="text-xl text-gray-500 line-through">
//                     ₹{original}/{planType.slice(0, 2)}
//                   </span>
//                 </div>

//                 {discount && (
//                   <div className="text-sm text-gray-300 font-semibold mb-4">
//                     Save {discount}% by billing {planType}
//                   </div>
//                 )}

//                 <NavLink
//                   to={link}
//                   target="_blank"
//                   className={`block w-full ${
//                     plan.isPopular === "Yes"
//                       ? "bg-gradient-to-r from-[#ffffff] via-[#f55fff] to-[#0047FF] hover:opacity-90 border border-customBlue"
//                       : "bg-black/20 border border-customBlue hover:bg-gradient-to-r from-[#ffffff] via-[#f55fff] to-[#0047FF]"
//                   } text-white font-semibold py-4 text-[18px] rounded-md shadow-md transition duration-300`}
//                 >
//                   {plan.subscription_button_name}
//                 </NavLink>

//                 <h4 className="text-white text-[20px] mt-8 text-left">{heading}</h4>

//                 <ul className="mt-3 space-y-3 text-gray-300 text-sm w-full text-left list-none">
//                   {plan.features.map((feature, idx) => (
//                     <li key={idx} className="flex items-center gap-2">
//                       <span className="h-[22px] w-[22px] bg-[#3d3d3d] text-white text-[12px] rounded-full flex items-center justify-center">
//                         <GiCheckMark />
//                       </span>
//                       <span>{feature}</span>
//                     </li>
//                   ))}
//                 </ul>
//               </div>
//             );

//             return (
//               <div key={index} className="flex flex-col h-full w-full">
//                 {plan.isPopular === "Yes" ? (
//                   <div className="bg-gradient-to-r from-[#0068FF2e] to-[#00C6FF2e] rounded-2xl p-[2px] h-full flex flex-col">
//                     <div className="text-white text-sm font-bold text-center py-2 rounded-t-2xl bg-black/60">
//                       Most Popular
//                     </div>
//                     <div className="flex-grow flex flex-col rounded-b-2xl">{card}</div>
//                   </div>
//                 ) : (
//                   card
//                 )}
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     </div>


// <section className="bg-black py-20 pt-8 px-4 relative overflow-hidden">
//   {/* Glow Effects Background */}
//   <div className="pointer-events-none absolute inset-0 z-0">
//     <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[1000px] h-[1000px] rounded-full bg-[#0068FF] opacity-[0.3] blur-[220px]" />
//     <div className="absolute bottom-0 right-0 w-[700px] h-[700px] rounded-full bg-[#f400ffd1] opacity-[0.3] blur-[200px]" />
//   </div>

//   <div className="relative z-10 max-w-7xl mx-auto text-center">
//     <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4 tracking-tight">
//       What Our{" "}
//       <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#ffffff] via-[#f55fff] to-[#0047FF]">
//         Learners Say
//       </span>
//     </h1>
//     <p className="text-gray-400 max-w-2xl mx-auto text-base md:text-lg mb-12">
//       Hear how creators like you are transforming with our AI-powered training.
//     </p>

//     {/* Video Testimonials */}
//     <div className="grid gap-6 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mb-10">
//       {videoTestimonials.map((video, index) => (
//         <div
//           key={index}
//           className="rounded-2xl overflow-hidden shadow-xl shadow-[#00C6FF]/4 hover:shadow-[#00C6FF]/30 transition-shadow duration-300 border border-white/10 bg-white/5 backdrop-blur-md"
//         >
//           <iframe
//             className="w-full aspect-video rounded-xl"
//             src={video.url}
//             title={`Video testimonial ${index + 1}`}
//             frameBorder="0"
//             allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//             allowFullScreen
//           ></iframe>
//         </div>
//       ))}
//     </div>

//     {/* Text Testimonials */}
//     <div
//       className={`grid gap-10 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 transition-all duration-500 ease-in-out ${
//         showAll ? "max-h-full" : "max-h-[2400px] overflow-hidden"
//       }`}
//     >
//       {(showAll ? testimonials : testimonials.slice(0, 6)).map((t, i) => (
//         <div
//           key={i}
//           className="relative p-6 rounded-2xl bg-white/5 backdrop-blur-md border border-white/10 text-white shadow-xl shadow-[#00C6FF]/3 hover:shadow-[#00C6FF]/30 transition-transform duration-300 hover:scale-[1.02] flex flex-col justify-between"
//         >
//           <div className="text-left mb-4">
//             <FaQuoteLeft className="text-4xl text-[#00bf67] drop-shadow-[0_1px_10px_rgba(0,198,255,0.4)]" />
//           </div>
//           <p className="text-left leading-relaxed italic text-white/90 text-sm md:text-base">
//             {t.text}
//           </p>
//           <div className="flex items-center gap-4 pt-6 mt-6 border-t border-white/10">
//             <img
//               src={t.icon}
//               alt={t.name}
//               className="w-12 h-12 object-cover rounded-full border border-white/10"
//             />
//             <div className="text-left">
//               <h6 className="font-semibold text-base">{t.name}</h6>
//               <p className="text-sm text-white/70">{t.course}</p>
//             </div>
//           </div>
//         </div>
//       ))}
//     </div>
//   </div>
// </section>



// {/* Accordion List */}
// <div className="bg-black py-12 relative overflow-hidden">
//   {/* Soft Background Glow */}
//   <div className="pointer-events-none absolute inset-0 z-0">
//     <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[900px] h-[900px] rounded-full bg-[#0014ff] opacity-[0.15] blur-[220px]" />
//     <div className="absolute bottom-0 right-0 w-[600px] h-[600px] rounded-full bg-[#0068FF] opacity-[0.06] blur-[200px]" />
//   </div>

//   <section className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 md:px-10 text-white rounded-2xl shadow-xl backdrop-blur-md ">
//     <h3 className="text-4xl md:text-5xl font-bold text-center mb-10">
//       Frequently Asked{" "}
//       <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#ffffff] via-[#f55fff] to-[#0047FF]">
//         Questions
//       </span>
//     </h3>

//     <div className="space-y-5">
//       {faqs.map((faq, index) => (
//         <div
//           key={index}
//           className={`transition-all duration-300 rounded-xl ${
//             openIndex === index
//               ? "bg-gradient-to-r from-[#00bf67] to-[#0068ff] p-[1.5px] shadow-md shadow-[#00C6FF]/20"
//               : "border border-white/10"
//           }`}
//         >
//           <div className="bg-white/5 backdrop-blur-md rounded-xl">
//             <button
//               onClick={() => toggleFAQ(index)}
//               className="w-full flex justify-between items-center px-5 py-4 text-left"
//             >
//               <span className="text-lg font-medium">{faq.question}</span>
//               <div
//                 className={`transition-transform duration-300 rounded-full p-1 ${
//                   openIndex === index
//                     ? "rotate-180 bg-gradient-to-tr from-[#0068FF] to-[#00C6FF] text-white"
//                     : "text-white/60"
//                 }`}
//               >
//                 <IoChevronDownSharp className="text-xl" />
//               </div>
//             </button>
//             <div
//               className={`overflow-hidden transition-all duration-300 px-5 text-gray-300 ${
//                 openIndex === index ? "max-h-96 pb-5" : "max-h-0"
//               }`}
//             >
//               {openIndex === index && (
//                 <div className="pt-1 whitespace-pre-line">{faq.answer}</div>
//               )}
//             </div>
//           </div>
//         </div>
//       ))}
//     </div>
//   </section>
// </div>






//       <CallToAction />
//       </div>
//       <Footer />
//       <MobileFooter />
//     </>
//   );
// };

// export default Home2;



import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import axios from 'axios';
import { BsCheckLg } from 'react-icons/bs';
import { HiArrowLongRight } from 'react-icons/hi2';
import TopBar from '../components/TopBar';
import Header from '../components/headerfooter/Header';
import Footer from '../components/headerfooter/Footer';
import MobileFooter from '../components/MobileFooter';
import HeroBanner from '../components/home/HeroBanner';
import JustLaunched from '../components/home/JustLaunched';
import CallToAction from '../components/home/CallToAction';
import Loader from '../components/Loader';
import { ChevronDown } from "lucide-react";
import { IoChevronDownSharp } from "react-icons/io5";
import { FaQuoteLeft, FaUserFriends } from "react-icons/fa";
import { FaCheck, FaTimes } from "react-icons/fa";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { IMAGE_URL, REACT_APP_API_PORT } from '../Api';
import { NavLink } from "react-router-dom";
import { GiCheckMark } from "react-icons/gi";
import { FaInstagram, FaYoutube, FaUsers, FaEye } from "react-icons/fa";
import ReactPlayer from 'react-player';
import StarRating from '../components/StarRating';
import { MdTravelExplore } from 'react-icons/md';
import { SiOpenai } from 'react-icons/si';
import { BiConversation } from 'react-icons/bi';
import { getDecryptedData } from '../config/crypto';
import WhatsAppChatButton from '../components/WhatsAppChatButton';
import { Helmet } from 'react-helmet';
import MembershipCard2 from './socialpage/component/MembershipCard2';
import { FaBolt, FaGift } from "react-icons/fa";
import { FaUserGraduate, FaClock, FaStar ,FaTag } from "react-icons/fa";
const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: 'easeOut' },
  },
};

function highlightMultipleKeywords(text, keywords) {
  const regex = new RegExp(`(${keywords.join("|")})`, "gi");
  const parts = text.split(regex);

  return parts.map((part, index) =>
    keywords.includes(part) ? (
      <span
        key={index}
        className="bg-gradient-to-r from-[#ffffff] via-[#f55fff] to-[#0047FF] bg-clip-text text-transparent"
      >
        {part}
      </span>
    ) : (
      <React.Fragment key={index}>{part}</React.Fragment>
    )
  );
}

const plansData = [
  {
    title: "🧑‍💻 AI Basic (Kickstart with AI)",
    subtitle: "For Students Starting with AI",
    isPopular: "No",
    plans: ["Monthly", "Quarterly", "Yearly"],
    monthly_selling_price: 199,
    monthly_original_price: 349,
    monthly_discount: 43,
    quarterly_selling_price: 597,
    quarterly_original_price: 1050,
    quarterly_discount: 43,
    yearly_selling_price: 1990,
    yearly_original_price: 4200,
    yearly_discount: 53,
    monthly_subscription_link: "#",
    quarterly_subscription_link: "#",
    yearly_subscription_link: "#",
    subscription_button_name: "Buy Now",
    features_heading_monthly: "Essential features to start",
    features_heading_quarterly: "Essential features to start",
    features_heading_yearly: "Essential features to start",
    features: [
      "100+ Premium Video Prompts",
      "500+ Expert Image Prompts",
      "100+ Downloadable AI Guides",
      "Private Community Access",
      "Fresh Content Every Week"
    ]
  },
  {
    title: "👑 AI Premium (Earn with AI)",
    subtitle: "For Mastering AI & Earning Big",
    isPopular: "Yes",
    plans: ["Monthly", "Quarterly", "Yearly"],
    monthly_selling_price: 999,
    monthly_original_price: 1999,
    monthly_discount: 50,
    quarterly_selling_price: 2997,
    quarterly_original_price: 5997,
    quarterly_discount: 50,
    yearly_selling_price: 9990,
    yearly_original_price: 23988,
    yearly_discount: 58,
    monthly_subscription_link: "#",
    quarterly_subscription_link: "#",
    yearly_subscription_link: "#",
    subscription_button_name: "Buy Now",
    features_heading_monthly: "Everything in Start, plus",
    features_heading_quarterly: "Everything in Start, plus",
    features_heading_yearly: "Everything in Start, plus",
    features: [
      "Unlimited Video + Image Prompts",
      "Early Access to All Courses",
      "Monthly Live Q&A / AMA with Satyam",
      "Private WhatsApp Community",
      "1 Free 1:1 Strategy Call (Quarterly)",
      "Access to Guest Workshops",
      "All Pro Plan Features"
    ]
  },
  {
    title: "🚀 AI Pro (Grow with AI)",
    subtitle: "For Hustlers Ready to Scale with AI",
    isPopular: "No",
    plans: ["Monthly", "Quarterly", "Yearly"],
    monthly_selling_price: 349,
    monthly_original_price: 500,
    monthly_discount: 30,
    quarterly_selling_price: 1047,
    quarterly_original_price: 1500,
    quarterly_discount: 30,
    yearly_selling_price: 3489,
    yearly_original_price: 6000,
    yearly_discount: 42,
    monthly_subscription_link: "#",
    quarterly_subscription_link: "#",
    yearly_subscription_link: "#",
    subscription_button_name: "Buy Now",
    features_heading_monthly: "Everything in Basic, plus",
    features_heading_quarterly: "Everything in Basic, plus",
    features_heading_yearly: "Everything in Basic, plus",
    features: [
      "250+ Premium Video Prompts",
      "All Basic Plan Features",
      "Priority Access to New Tools",
      "Exclusive AI Tools & Challenges",
      "1 Free AI Course Module"
    ]
  }
];

 const students = [
    "6000+ students",
    // "8000+ students",
    "7000+ students",
    "4000+ students",
    "5000+ students",
    "5000+ students",
    "7000+ students",
    "5000+ students",
    "10000+ students",
    "8000+ students",
    "7000+ students",
    "9000+ students",
  ];

const features = [
  {
    title: "Explore the Ultimate Prompt Library",
    subtitle: "Features 2",
    description:
      "Discover a wide collection of AI prompts to supercharge your creativity, productivity, and workflow. Ideal for marketers, writers, developers, and more.",
    list: [
      "Daily updates on major AI advancements",
      "Stay informed on tools, trends, and best practices",
      "Visual and concise summaries for quick reading",
    ],
    buttonText: "Request A Demo",
    buttonLink: "/login",
    image: "/images/sec2.webp",
    reverse: true,
  },
  {
    title: "AI Courses That Level You Up",
    subtitle: "Features 1",
    description:
      "Master AI tools and technologies with our expertly crafted courses. Learn at your own pace and gain practical skills to apply AI in real-world projects and businesses.",
    list: [
      "Hands-on courses covering top AI tools and use cases",
      "Learn how to apply AI to real-world problems",
      "Visual guides and video lessons to enhance learning",
    ],
    buttonText: "Get Started Free",
    buttonLink: "/login",
    image: "/images/sec1.webp",
    reverse: false,
  },

  {
    title: "Latest in AI News",
    subtitle: "Features 3",
    description:
      "Stay ahead in the AI world with curated news, trends, and updates. Get insights into the latest AI breakthroughs, research, tools, and industry movements.",
    list: [
      "Daily updates on major AI advancements",
      "Stay informed on tools, trends, and best practices",
      "Visual and concise summaries for quick reading",
    ],
    buttonText: "Get Started Free",
    buttonLink: "/login",
    image: "/images/sec3.webp",
    reverse: false,
  },
];

const faqs = [
  {
    question: "What is NextFutureAI and how does it work?",
    answer:
      "NextFutureAI is an online platform for creator educators that allows you to create, market, and sell courses, communities, memberships, digital downloads, coaching, webinars, and other digital products.\n\nYou can easily sell to both consumers and other businesses (B2B and B2C) using intuitive, easy-to-use tools and AI assistance.",
  },
  {
    question: "Is it easy to get started?",
    answer:
      "NextFutureAI is an online platform for creator educators that allows you to create, market, and sell courses, communities, memberships, digital downloads, coaching, webinars, and other digital products.\n\nYou can easily sell to both consumers and other businesses (B2B and B2C) using intuitive, easy-to-use tools and AI assistance.",
  },
  {
    question: "Can I cancel or change my account at any time?",
    answer:
      "NextFutureAI is an online platform for creator educators that allows you to create, market, and sell courses, communities, memberships, digital downloads, coaching, webinars, and other digital products.\n\nYou can easily sell to both consumers and other businesses (B2B and B2C) using intuitive, easy-to-use tools and AI assistance.",
  },
  {
    question: "I already have a website. Can I integrate it with NextFutureAI?",
    answer:
      "NextFutureAI is an online platform for creator educators that allows you to create, market, and sell courses, communities, memberships, digital downloads, coaching, webinars, and other digital products.\n\nYou can easily sell to both consumers and other businesses (B2B and B2C) using intuitive, easy-to-use tools and AI assistance.",
  },
  {
    question: "Do I need a separate web hosting?",
    answer:
      "NextFutureAI is an online platform for creator educators that allows you to create, market, and sell courses, communities, memberships, digital downloads, coaching, webinars, and other digital products.\n\nYou can easily sell to both consumers and other businesses (B2B and B2C) using intuitive, easy-to-use tools and AI assistance.",
  },
  {
    question: "Does NextFutureAI have a marketplace?",
    answer:
      "NextFutureAI is an online platform for creator educators that allows you to create, market, and sell courses, communities, memberships, digital downloads, coaching, webinars, and other digital products.\n\nYou can easily sell to both consumers and other businesses (B2B and B2C) using intuitive, easy-to-use tools and AI assistance.",
  },
  // Add more FAQs as needed
];

const testimonials = [
  {
    text: `"I run a digital marketing agency and found this course through Instagram ads. The storytelling segment and process-oriented approach were valuable, but I’d rate it 8.5/10, as the Instagram course could include more on branding and business."`,
    name: "Pratik",
    course: "Video Editing Course",
    icon: "https://cdn.prod.website-files.com/65f02985a70b38d810964d03/679c6e21bd94aef22a77beb5_Icon%20Strategy%20(10).svg",
  },
  {
    text: `"Highly informative and helpful, especially for a beginner like me. The art of conversation and outreach segments were the most beneficial. I’d recommend this course to anyone pursuing podcasting and would rate it 8.5/10."`,
    name: "Abhay Maheshwari",
    course: "Podcasting 101",
    icon: "https://cdn.prod.website-files.com/65f02985a70b38d810964d03/679c6e224dd18feef88a0801_Icon%20Strategy%20(15).svg",
  },
  {
    text: `"I found this course through Instagram ads, and the monetizing strategies were really insightful. While I would have loved more in-depth content on Meta and Instagram monetization, I’d still rate the course 9.5/10 for its value and help!"`,
    name: "Shubham Shinde",
    course: "Monetising Content creation",
    icon: "https://cdn.prod.website-files.com/65f02985a70b38d810964d03/679c6e22cfa7a1910d852790_Icon%20Strategy%20(17).svg",
  },
  {
    text: `"I’m a 42-year-old jewelry business owner in Bengaluru, and I took this course to learn about Instagram for my business. I really enjoyed the course, especially the insights on AI and prompt engineering, though I wish it was a bit longer. I’d rate it 8/10 and have recommended it to friends!"`,
    name: "Jhansi Upputuri",
    course: "Instagram 101",
    icon: "https://cdn.prod.website-files.com/65f02985a70b38d810964d03/6799ddd30ce470e2148d53f8_Icon%20Strategy%20(11).svg",
  },
  {
    text: `"I'm a photographer and video editor who discovered your course through The Ranveer Show and Instagram. It taught me valuable new skills, though more detailed breakdowns of complex techniques would enhance it—9/10 overall!"`,
    name: "Shreya Yadav",
    course: "Video Editing Course",
    icon: "https://cdn.prod.website-files.com/65f02985a70b38d810964d03/679c6e21406c4123d2680bee_Icon%20Strategy%20(2).svg",
  },
  {
    text: `"As a beginner, I found this course incredibly helpful, learning many new insights and detailed knowledge. I'm starting a solo podcast and plan to apply these learnings. As a big fan of Ranveer, I’d rate it 10/10 and highly recommend it."`,
    name: "Apprna Walia",
    course: "Podcasting 101",
    icon: "https://cdn.prod.website-files.com/65f02985a70b38d810964d03/679c6e2248e62cb35887ed81_Icon%20Strategy%20(12).svg",
  },
  {
    text: `"I discovered this course through Facebook and Instagram, and it served as a great refresher with insightful content and excellent mentors. Despite a minor app issue, I found the course perfect for launching my social media channel, and I’d rate it 10/10."`,
    name: "Pradnya Shinde",
    course: "Monetising Content creation",
    icon: "https://cdn.prod.website-files.com/65f02985a70b38d810964d03/679c6e21001cc3a4c10f5012_Icon%20Strategy%20(3).svg",
  },
  {
    text: `"I bought the course out of curiosity, and I'm glad I did! I'm pursuing a postgraduate degree in Architecture, and I found the course insightful, especially the first five modules. Although the later modules felt repetitive, they were still necessary. I'd recommend this course to anyone looking to improve their Instagram game and have already suggested it to a few friends. I'd rate it 8/10."`,
    name: "Sipun Naik",
    course: "Instagram 101",
    icon: "https://cdn.prod.website-files.com/65f02985a70b38d810964d03/679c6e227d9046f26ed8d436_Icon%20Strategy%20(5).svg",
  },
  {
    text: `"I run a chocolate business and took this course to learn reel editing. The mentors explained everything clearly, though I faced challenges with raw footage access and lack of software—overall a great course, but I’ll rate it fully after completing it."`,
    name: "Deepali Bahadur",
    course: "Video Editing Course",
    icon: "https://cdn.prod.website-files.com/65f02985a70b38d810964d03/679c6e23fc527c2e490b586a_Icon%20Strategy%20(9).svg",
  },
];

const courses = [
  {
    title: 'AI 3D Cartoon Animation Video Course',
    price: '₹350',
    img: '/images/course1.png',
    link: 'https://tr.ee/yhvSpN',
  },
  {
    title: 'AI Miniature Video Course',
    price: '₹199',
    img: '/images/course2.png',
    link: 'https://satyamai.rpy.club/course/wz2za35EOP',
  },
  {
    title: 'CGI Ads Mastery with AI - Course',
    price: '₹349',
    oldPrice: '₹1999',
    img: '/images/course3.png',
    link: 'https://satyamai.rpy.club/course/4BxvYpdHNV',
  },
  {
    title: 'Viral AI Ads & Branding Masterclass with ChatGPT',
    price: '₹599',
    img: '/images/course4.png',
    link: 'https://tr.ee/Ftb1XX',
  },
];

const videoTestimonials = [
  { url: "https://www.youtube.com/embed/LNLUypwL0aU?si=M7gQ3k8OmvEMOAn5" },
  { url: "https://www.youtube.com/embed/_6WVxRNM8MA?si=U1bUhaA-xW2c673c" },
  { url: "https://www.youtube.com/embed/Byz8XoyS8Lo?si=_6lzz2IgCiuxPEN1" },
  { url: "https://www.youtube.com/embed/LNLUypwL0aU?si=M7gQ3k8OmvEMOAn5" },
  { url: "https://www.youtube.com/embed/_6WVxRNM8MA?si=U1bUhaA-xW2c673c" },
  { url: "https://www.youtube.com/embed/Byz8XoyS8Lo?si=_6lzz2IgCiuxPEN1" },
];

const Home2 = () => {
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [meta, setMeta] = useState([]);
  const [additionalData, setadditionalData] = useState([]);
  const [subscriptionData, setsubscriptionData] = useState([]);
  const [discount, setDiscount] = useState([]);
  const [planType, setPlanType] = useState("Monthly");
  const [visibleFeatures, setVisibleFeatures] = useState({});
  const [showAll, setShowAll] = useState(false);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(
        `${REACT_APP_API_PORT}user/homepage/nextfutureai_homepage_details`
      );
      if (res.data.status) {
        setData(res.data.data)
        if (res.data.additionalData) {
          setadditionalData(res.data.additionalData)
        }
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchMetaData = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(
        `${REACT_APP_API_PORT}user/homepage/page-seo-details/Nextfutureai Homepage`
      );
      if (res.data.status) {
        setMeta(res.data.data)
        
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  useEffect(() => {
    fetchData();
    fetchMetaData()
  }, []);


  // const [planType, setPlanType] = useState("Monthly");
  // const discount = { discount: "Best Value" };

  const getSubscriptionData = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(
        `${REACT_APP_API_PORT}user/homepage/activesubscription`
      );
      setIsLoading(false);
      setsubscriptionData(res.data.data);
    } catch (err) {
      setIsLoading(false);
      console.log(err);
    }
  };

  const getYearlyDiscountData = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(
        `${REACT_APP_API_PORT}user/homepage/get-yearly-discount`
      );
      setIsLoading(false);
      setDiscount(res.data.data);
    } catch (err) {
      setIsLoading(false);
      console.log(err);
    }
  };

  useEffect(() => {
    getSubscriptionData()
    getYearlyDiscountData()
  }, [])

  // const sortedData = [...subscriptionData].sort((a, b) => {
  //   if (data.length === 3) {
  //     if (a.isPopular === "Yes") return -1;
  //     if (b.isPopular === "Yes") return 1;
  //     return a.title.localeCompare(b.title);
  //   }
  //   return 0;
  // });
  // const finalData = subscriptionData.length === 3 ? [
  //   sortedData[1], // Non-popular plan
  //   sortedData[0], // Popular plan
  //   sortedData[2]  // Non-popular plan
  // ] : sortedData;
  const sortedData = [...subscriptionData].sort((a, b) => {
    if (subscriptionData.length === 3) {
      if (a.isPopular === "Yes") return -1;
      if (b.isPopular === "Yes") return 1;
      return a.title.localeCompare(b.title);
    }
    return 0;
  });

  let finalData = sortedData;

  // If exactly 3 plans and only one is popular
  if (subscriptionData.length === 3) {
    const popularIndex = sortedData.findIndex(item => item.isPopular === "Yes");

    if (popularIndex !== -1 && sortedData.filter(item => item.isPopular === "Yes").length === 1) {
      const popularPlan = sortedData.splice(popularIndex, 1)[0];
      finalData = [sortedData[0], popularPlan, sortedData[1]];
    }
  }


  const stats = [
    {
      icon: <FaUserFriends className="text-pink-500 w-8 h-8" />,
      value: data?.section1_instagram_followers,
      label: "Total Followers",
    },
    {
      icon: <MdTravelExplore className="text-red-500 w-8 h-8" />,
      value: data?.section1_youtube_subscribers,
      label: "Account Reached",
      label2: "(Last 90 Days)",
    },
    {
      icon: <SiOpenai className="text-blue-500 w-8 h-8" />,
      value: data?.section1_members,
      label: "AI Community Learners",
    },
    {
      icon: <BiConversation className="text-green-500 w-8 h-8" />,
      value: data?.section1_views,
      label: "Interactions",
      label2: "(Last 90 Days)",
    },
  ];

  const stats2 = [
    {
      icon: <FaInstagram className="text-pink-500 w-8 h-8" />,
      value: data?.section2_instagram_followers,
      label: "Followers",
    },
    {
      icon: <FaYoutube className="text-red-500 w-8 h-8" />,
      value: data?.section2_youtube_subscribers,
      label: "Subscribers",
    },
    {
      icon: <FaUsers className="text-blue-500 w-8 h-8" />,
      value: data?.section2_members,
      label: "Members",
    },
    {
      icon: <FaEye className="text-green-500 w-8 h-8" />,
      value: data?.section2_views,
      label: "Views",
    },
  ];

  const HtmlContent = ({ content }) => {
    return <div dangerouslySetInnerHTML={{ __html: content }} />;
  };

  const handleOpenPrompt = async(link) =>{
    const token = getDecryptedData("token")
    if(token){
      window.location.href = link
    }else{
      navigate("/login")
    }
  }

  return (
    <div className='overflow-hidden'>
     <Helmet>
        <title>{meta?.meta_title}</title>
        <meta name="description" content={meta?.meta_description} />
        <meta name="keywords" content={meta?.meta_keywords} />
      </Helmet>
      <Loader isLoading={isLoading} />
      {/* <TopBar /> */}
      <Header />
      {/* <WhatsAppChatButton /> */}
      {/* <HeroBanner /> */}
      <div className=''>
        {
          (data?.section1_status === "Active") && <>
            <section className="relative overflow-hidden bg-background-back1 text-white pb-20 pt-[120px] lg:pb-[50px] lg:pt-[140px] font-sans">
              {/* 🔥 Gradient Glow Backgrounds */}
              <div className="pointer-events-none absolute inset-0 z-0">
                {/* Blue Glow Left */}
                <div className="absolute top-[-150px] left-[-100px] h-[600px] w-[600px] bg-[radial-gradient(circle,rgba(0,102,255,0.5)_0%,transparent_70%)] blur-[120px]"></div>

                {/* Purple-Pink Glow Right */}
                <div className="absolute bottom-[-100px] right-[-100px] h-[500px] w-[500px] bg-[radial-gradient(circle,rgba(28,0,225,0.90)_0%,transparent_70%)] blur-[100px]"></div>

                {/* Greenish Cyan Glow Center-Left */}
                <div className="absolute bottom-[10%] left-[25%] h-[300px] w-[300px] bg-[radial-gradient(circle,rgba(0,255,171,0.4)_0%,transparent_70%)] blur-[90px]"></div>
              </div>

              {/* Main Content */}
              <div className="relative z-10 mx-auto max-w-7xl px-6 sm:px-8 lg:px-12">
                <div className="flex flex-col items-center text-center gap-6 md:gap-6">
                  {/* Heading Section */}
                  <motion.h1 className="text-[45px] font-extrabold leading-tight tracking-tight lg:text-[80px]"
                    variants={fadeUp}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    data-aos="fade-up-sm"
                    data-aos-delay={100} >
                    {data?.section1_heading}&nbsp;
                    <span className="bg-gradient-to-r from-[#ffffff] via-[#f55fff] to-[#0047FF] bg-clip-text text-transparent drop-shadow-lg">
                      {data?.section1_heading2}
                    </span>
                  </motion.h1>

                  <motion.p className="mt-0 md:mt-4 max-w-5xl text-lg leading-relaxed text-gray-300 max-w-[700px] sm:text-xl lg:text-[24px]"
                    variants={fadeUp}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    data-aos="fade-up-sm"
                    data-aos-delay={200}>
                    <HtmlContent content={data?.section1_description} />
                  </motion.p>

                  {/* CTA Buttons */}
                  <motion.div className="flex flex-wrap justify-center gap-6 mt-5"
                    variants={fadeUp}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    data-aos="fade-up-sm"
                    data-aos-delay={300}>
                    {data?.section1_button_name && (
                      <Link to={data?.section1_button_link} target='_blank'>
                        <button
                          className="block md:w-auto w-full text-center px-10 text-[18px] py-5 rounded-lg text-white transition-transform hover:scale-105 font-semibold bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)] hover:bg-[linear-gradient(45deg,#ff7a18,#ff0066,#9b30ff,#3a7bd5)] transition-all duration-300 shadow-lg"
                          type="button"
                        >
                          {data?.section1_button_name}
                        </button>
                      </Link>
                    )}

                    {data?.section1_button2_name && <>
                      {/* <Link to={data?.section1_button2_link} target='_blank'> */}
                        <button
                          onClick={()=>{
                            handleOpenPrompt(data?.section1_button2_link)
                          }}
                          className="rounded-lg px-10 text-[18px] py-5 text-white font-semibold transition-transform hover:scale-105 hover:text-white hover:bg-[linear-gradient(45deg,#ff7a18,#ff0066,#9b30ff,#3a7bd5)] border-2 border-customBlue focus:ring-4 focus:ring-gray-500 duration-200 shadow-lg"
                          type="button"
                        >
                          {data?.section1_button2_name}
                        </button>
                      {/* </Link> */}
                    </>}
                  </motion.div>
                </div>
                <section className="relative py-12">
                  {/* Optional: Subtle blurred background glow */}


                  <div className="relative max-w-6xl mx-auto px-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 z-10">
                    {stats.map((stat, index) => (
                      <div
                        key={index}
                        className={`flex flex-col items-center bg-white/5 rounded-2xl p-6 shadow-xl 
                    hover:shadow-[0_0_25px_#000] transition-all duration-300 group`}
                      >
                        <div className="mb-4 transition-transform duration-300 group-hover:scale-110">
                          {stat.icon}
                        </div>
                        <h3 className="text-2xl font-bold text-white">{stat.value}</h3>
                        <p className="text-gray-400">{stat.label}</p>
                        <p className="text-gray-400">{stat.label2}</p>
                      </div>
                    ))}
                  </div>
                </section>
              </div>
            </section>
          </>
        }

        {
          (data?.section2_status === "Active") && <>
           
            <section className="relative bg-black text-white py-20 px-4 sm:py-28 overflow-hidden">
              {/* Background gradient glow */}
              <div className="absolute inset-0 bg-gradient-to-br from-[#0f0f0f] via-black to-[#1a1a1a] opacity-90 z-0" />

              {/* Subtle glowing circles */}
              <div className="absolute -top-32 -left-32 w-72 h-72 sm:w-[400px] sm:h-[400px] bg-purple-500 opacity-20 rounded-full blur-3xl" />
              <div className="absolute top-1/2 -right-24 w-60 h-60 sm:w-[300px] sm:h-[300px] bg-fuchsia-500 opacity-10 rounded-full blur-2xl" />

              <div className="relative z-10 max-w-6xl mx-auto text-center">
                {/* Title */}
                <h2 className="text-3xl sm:text-5xl md:text-6xl font-extrabold tracking-tight mb-4 sm:mb-6 leading-tight">
                  {data?.section2_heading}{" "}
                  <span className="bg-gradient-to-r from-[#ffffff] via-[#f55fff] to-[#0047FF] bg-clip-text text-transparent drop-shadow-lg">
                    {data?.section2_heading2}
                  </span>
                </h2>
                <p className="text-base sm:text-xl md:text-2xl text-gray-400 mb-8 sm:mb-14 max-w-md sm:max-w-2xl mx-auto">
                  {data?.section2_description}
                </p>
                <div className="relative mx-auto w-full aspect-video max-w-full sm:max-w-5xl rounded-2xl sm:rounded-3xl overflow-hidden border border-white/10 shadow-2xl backdrop-blur-md bg-white/5">
                  {data?.section2_youtube_link && (
                    <ReactPlayer
                      url={data.section2_youtube_link}
                      width="100%"
                      height="100%"
                      controls
                      className="absolute top-0 left-0"
                    />
                  )}
                </div>
              </div>
            </section>

          </>
        }


        <div>
          {/* Overlay */}

          {/* <JustLaunched setisLoading={setIsLoading} /> */}
          {
            (data?.section3_status === "Active") && <>
              <section className="relative py-24 bg-black text-white overflow-visible">
                
                <div className="pointer-events-none absolute inset-0 z-0 overflow-hidden">
                  <div
                    className="absolute -top-[0px] -left-[300px] w-[1000px] h-[1000px] rounded-full blur-[220px] opacity-60 animate-pulse-glow"
                    style={{
                      background: "radial-gradient(circle at center, rgba(0, 8, 255, 0.86), transparent 70%)",
                    }}
                  />
                  <div
                    className="absolute -bottom-[300px] -right-[300px] w-[900px] h-[900px] rounded-full blur-[200px] opacity-60 animate-pulse-glow"
                    style={{
                      background: "radial-gradient(circle at center, rgba(0, 102, 255, 0.81), transparent 70%)",
                    }}
                  />
                </div>

                <div className="relative z-10 max-w-[90rem] mx-auto px-4">
                 
                  <div className='text-center'>
                    <h2 className="text-3xl sm:text-5xl md:text-6xl font-extrabold tracking-tight mb-4 sm:mb-6 leading-tight">
                      {data?.section3_heading}{" "}
                      <span className="bg-gradient-to-r from-[#ffffff] via-[#f55fff] to-[#0047FF] bg-clip-text text-transparent drop-shadow-lg">
                        {data?.section3_heading2}
                      </span>
                    </h2>
                  </div>


                  <Swiper
                  slidesPerView={1}
                  spaceBetween={16}
                  centeredSlides={false}
                  breakpoints={{
                    640: { slidesPerView: 2.1, centeredSlides: false },
                    1024: { slidesPerView: 3.1 },
                  }}
                  className="px-4 sm:px-2 overflow-hidden"
                >

                    {additionalData && additionalData?.courseData?.map((c, i) => (
                      // <SwiperSlide key={i} className='pt-[42px] pb-[42px]'>
                      //   <motion.div
                      //     whileInView={{ opacity: 1, y: 0 }}
                      //     initial={{ opacity: 0, y: 40 }}
                      //     transition={{ delay: i * 0.1, duration: 0.5, ease: "easeOut" }}
                      //   >
                      //     <div className="group flex flex-col bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl overflow-hidden shadow-2xl transition-transform duration-300 hover:scale-[1.03] hover:shadow-[0_0_50px_rgba(0,198,255,0.25)]">
                      //       {c?.course_id?.course_category?.name && (
                      //         <div className="absolute top-2 right-4 bg1-[#00C6FF] bg-green-600 text-white text-xs font-semibold px-3 py-1 rounded-full shadow-md z-10">
                      //           {c.course_id.course_category.name}
                      //         </div>
                      //       )}


                      //       <img
                      //         src={IMAGE_URL + c?.course_id?.banner || '/just-launch-default.png'}
                      //         onError={(e) => {
                      //           e.target.src = '/just-launch-default.png'
                      //         }}
                      //         alt={c.title}
                      //         className="w-full h-66 object-cover rounded-t-2xl"
                      //       />
                      //       <div className="p-6 flex flex-col justify-between flex-grow space-y-5">
                    
                      //         <h3 className="text-2xl font-bold text-white truncate group-hover:text-[#00C6FF] transition duration-300">
                      //           {c?.course_id?.course_name}
                      //         </h3>

                      //         <p className="text-base text-gray-300 leading-relaxed line-clamp-3">
                      //           {c.description || (
                      //             <span className="italic text-gray-400">
                      //               {c?.course_id?.section1_description}
                      //             </span>
                      //           )}
                      //         </p>
                      //         <StarRating rating={c?.course_id?.course_rating || 4} />

                      //         <div className="flex items-center gap-4 mt-auto">
                               
                      //           {c.course_id?.discount > 0 && (
                      //             <span className="bg-green-600 text-white text-xs font-semibold px-2 py-1 rounded-full">
                      //               {c.course_id.discount}% OFF
                      //             </span>
                      //           )}
                      //         </div>

                           
                      //         {c?.course_id?.course_landing_page_status === "Active" ? (
                      //           <NavLink
                      //             to={`/courses/${c?.course_id?.course_name
                      //               ?.toLowerCase()
                      //               .replace(/[^a-z0-9]+/gi, "-")
                      //               .replace(/^-+|-+$/g, "")}`}
                      //             state={{ id: c?.course_id?._id }}
                      //             className="inline-block w-full text-center px-5 py-3 rounded-lg font-semibold text-white text-lg bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)] hover:bg-[linear-gradient(45deg,#ff7a18,#ff0066,#9b30ff,#3a7bd5)] transition-all duration-300 shadow-lg"
                      //           >
                      //             Enroll Now
                      //           </NavLink>
                      //         ) : (
                      //           <a
                      //             href={c?.course_id?.course_link}
                      //             target="_blank"
                      //             rel="noopener noreferrer"
                      //             className="inline-block w-full text-center px-5 py-3 rounded-lg font-semibold text-white text-lg bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)] hover:bg-[linear-gradient(45deg,#ff7a18,#ff0066,#9b30ff,#3a7bd5)] transition-all duration-300 shadow-lg"
                      //           >
                      //             Enroll Now
                      //           </a>
                      //         )}

                      //       </div>
                      //     </div>
                      //   </motion.div>
                      // </SwiperSlide>
                      <SwiperSlide key={i} className="pt-[42px] pb-[42px]">
                    <motion.div
                      whileInView={{ opacity: 1, y: 0 }}
                      initial={{ opacity: 0, y: 40 }}
                      transition={{ delay: i * 0.1, duration: 0.5, ease: "easeOut" }}
                    >
                      <div
                    className="
                      group flex flex-col
                      bg-white/10 backdrop-blur-xl
                      border border-white/20
                      rounded-2xl overflow-hidden
                      shadow-xl
                      transition-all duration-300
                      sm:hover:scale-[1.03]
                      sm:hover:border-blue-500
                    "
                  >

                          <div className="relative">
                            <img
                              src={IMAGE_URL + c?.course_id?.banner || "/just-launch-default.png"}
                              onError={(e) => (e.target.src = "/just-launch-default.png")}
                              alt={c?.course_id?.course_name}
                              className="w-full h-56 lg:h-64 object-cover rounded-t-2xl"
                            />

                            <div className="absolute inset-x-0 top-0 h-20 bg-gradient-to-b from-black/90 to-transparent rounded-t-2xl" />

                            <div className="absolute top-2 right-2">
                      {c?.course_id?.course_category?.name && (
                        <span className="bg-blue-600/80 text-white text-[10px] font-semibold px-2 py-0.5 rounded shadow">
                          {c.course_id.course_category.name}
                        </span>
                      )}
                    </div>

                          </div>

                          <div className="p-5 flex flex-col justify-between flex-grow space-y-3">
                            <h3 className="tracking-tight text-lg font-semibold leading-tight text-white/90">
                              {c?.course_id?.course_name}
                            </h3>

                            {/* <p className="text-sm text-neutral-400 line-clamp-2">
                              {c?.course_id?.section1_description}
                            </p> */}

                            <div className="flex items-center justify-between text-sm text-neutral-300 border-t border-white/10 pt-3.5">
                              <div className="flex items-center gap-2">
                                <FaUserGraduate className="text-emerald-400" />
                                <span> {students[i]}</span>
                              </div>

                              <div className="flex items-center gap-1">
                                <FaStar className="text-yellow-400" />
                                <span>{Number(c?.course_id?.course_rating || 4.5).toFixed(1)}</span>
                              </div>

                              {c?.course_id?.discount > 0 && (
                                <div className="flex items-center gap-1">
                                  <FaTag className="text-blue-400" />
                                  <span>{c.course_id.discount}% OFF</span>
                                </div>
                              )}
                            </div>

                            {c?.course_id?.course_landing_page_status === "Active" ? (
                              <NavLink
                                to={`/courses/${c?.course_id?.course_name
                                  ?.toLowerCase()
                                  .replace(/[^a-z0-9]+/gi, "-")
                                  .replace(/^-+|-+$/g, "")}`}
                                state={{ id: c?.course_id?._id }}
                                className="inline-block !mt-3.5 w-full text-center px-5 py-2 md:py-3 rounded-lg font-semibold text-white text-sm bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)] hover:bg-[linear-gradient(45deg,#ff7a18,#ff0066,#9b30ff,#3a7bd5)] transition-all duration-300 shadow-lg"
                              >
                                Enroll Now
                              </NavLink>
                            ) : (
                              <a
                                href={c?.course_id?.course_link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-block !mt-3.5 w-full text-center px-5 py-2 md:py-3 rounded-lg font-semibold text-white text-sm bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)] hover:bg-[linear-gradient(45deg,#ff7a18,#ff0066,#9b30ff,#3a7bd5)] transition-all duration-300 shadow-lg"
                              >
                                Enroll Now
                              </a>
                            )}
                          </div>
                        </div>
                      </motion.div>
                    </SwiperSlide>

                    ))}
                  </Swiper>

                </div>
              </section> 
            </>
          }

          {
            (data?.section4_status === "Active" || data?.section5_status === "Active" || data?.section6_status === "Active") && <>
              <section className="relative overflow-hidden bg-black py-24">
               
                <div className="pointer-events-none absolute inset-0 z-0 overflow-hidden">
                  {/* Top Glow */}
                  <div
                    className="absolute -top-[200px] left-[0px] -translate-x-1/2 w-[900px] h-[900px] rounded-2xl blur-[220px] opacity-70"
                    style={{
                      background:
                        "radial-gradient(circle at center, rgba(0, 102, 255, 0.75), transparent 80%)",
                    }}
                  />
                  {/* Middle Glow */}
                  <div
                    className="absolute top-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[1000px] rounded-2xl blur-[240px] opacity-70"
                    style={{
                      right: "-80%",
                      background:
                        "radial-gradient(circle at center, rgba(0, 85, 255, 0.6), transparent 85%)",
                    }}
                  />
                  {/* Bottom Glow */}
                  <div
                    className="absolute bottom-[100px] left-1/2 -translate-x-1/2 w-[1000px] h-[1000px] rounded-2xl blur-[200px] opacity-70"
                    style={{
                      background:
                        "radial-gradient(circle at center, rgba(0, 128, 255, 0.7), transparent 80%)",
                    }}
                  />
                </div>

                {/* Feature Cards */}

                <div className="relative z-10 container max-w-[80rem] mx-auto px-4 space-y-24">
                  {/* {features.map((feature, index) => {
              const isMiddleBox = index === 1;

              return (
                <div
                  key={index}
                  className="relative flex flex-col lg:flex-row items-center gap-10 p-1 rounded-[32px]"
                >
                  <div className="absolute inset-0 rounded-[32px] bg-gradient-to-br from-[#00C6FF66] via-[#FF00F733] to-[#00FFAA66] blur-[100px] z-0 opacity-40" />

                  <div className="relative z-10 w-full bg-white/5 backdrop-blur-2xl border border-white/10 rounded-[32px] p-6 md:p-14">
                    <div
                      className={`flex flex-col lg:flex-row items-center gap-10 ${isMiddleBox ? "lg:flex-row-reverse" : ""
                        }`}
                    >
                      <div className="lg:w-1/2">
                        <img
                          src={feature.image}
                          alt={feature.title}
                          className="w-full h-auto rounded-2xl shadow-xl"
                        />
                      </div>

                      <div className="lg:w-1/2 space-y-6">
                        <h2 className="text-[30px] md:text-[50px] leading-[56px] font-extrabold text-white drop-shadow-lg">
                          {highlightMultipleKeywords(feature.title, ["Prompt Library", "AI Courses", "AI News"])}
                        </h2>

                        <p className="text-gray-300 text-lg">{feature.description}</p>

                        {feature.list && (
                          <ul className="space-y-3 pt-2">
                            {feature.list.map((item, i) => (
                              <li
                                key={i}
                                className="flex items-start gap-3 text-white text-base"
                              >
                                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#0069ff] bg-opacity-20">
                                  <BsCheckLg className="text-[#00FFD1] text-lg" />
                                </div>
                                <span>{item}</span>
                              </li>
                            ))}
                          </ul>
                        )}

                        <Link
                          to={feature.buttonLink}
                          className="inline-flex items-center gap-2 mt-6 px-6 py-3 text-lg font-semibold bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)] hover:bg-[linear-gradient(45deg,#ff7a18,#ff0066,#9b30ff,#3a7bd5)] text-white rounded-xl shadow-lg transition duration-300 hover:scale-105"
                        >
                          {feature.buttonText}
                          <HiArrowLongRight className="text-xl" />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })} */}

                  {
                    (data?.section4_status === "Active") && <>
                      <div
                        className="relative flex flex-col lg:flex-row items-center gap-10 p-1 rounded-[32px]"
                      >
                        <div className="absolute inset-0 rounded-[32px] bg-gradient-to-br from-[#00C6FF66] via-[#FF00F733] to-[#00FFAA66] blur-[100px] z-0 opacity-40" />

                        <div className="relative z-10 w-full bg-white/5 backdrop-blur-2xl border border-white/10 rounded-[32px] p-6 md:p-14">
                          <div
                            className={`flex flex-col lg:flex-row items-center gap-10`}
                          >
                            <div className="lg:w-1/2">
                              <img
                                src={IMAGE_URL + data?.section4_image || '/placeholder-image.png'}
                                onError={(e) => {
                                  e.target.src = '/placeholder-image.png'
                                }}
                                className="w-full h-auto rounded-2xl shadow-xl"
                              />
                            </div>

                            <div className="lg:w-1/2 space-y-6">
                              {/* <h2 className="text-[30px] md:text-[50px] leading-[56px] font-extrabold text-white drop-shadow-lg">
                                {data?.section4_heading}
                              </h2>
                              <span
                                className="text-[30px] md:text-[50px] leading-[56px]  font-extrabold bg-gradient-to-r from-[#ffffff] via-[#f55fff] to-[#0047FF] bg-clip-text text-transparent"
                              >
                                {data?.section4_heading2}
                              </span> */}
                              <div className=''>
                                <h2 className="text-3xl sm:text-5xl md:text-6xl font-extrabold tracking-tight mb-4 sm:mb-6 leading-tight">
                                  {data?.section4_heading}{" "}
                                  <span className="bg-gradient-to-r from-[#ffffff] via-[#f55fff] to-[#0047FF] bg-clip-text text-transparent drop-shadow-lg">
                                    {data?.section4_heading2}
                                  </span>
                                </h2>
                              </div>


                              <p className="text-gray-300 text-lg">{data.section4_description}</p>
                              {data?.section4_points && (
                                <ul className="space-y-3 pt-2">
                                  {data?.section4_points?.split('|')?.map((item, i) => (
                                    <li
                                      key={i}
                                      className="flex items-start gap-3 text-white text-base"
                                    >
                                      <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#0069ff] bg-opacity-20">
                                        <BsCheckLg className="text-[#00FFD1] text-lg" />
                                      </div>
                                      <span>{item.trim()}</span>
                                    </li>
                                  ))}
                                </ul>
                              )}

                              {
                                data?.section4_button_link &&
                                <Link
                                  to={data?.section4_button_link}
                                  target='_blank'
                                  className="inline-flex items-center gap-2 mt-6 px-6 py-3 text-lg font-semibold bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)] hover:bg-[linear-gradient(45deg,#ff7a18,#ff0066,#9b30ff,#3a7bd5)] text-white rounded-lg shadow-lg transition duration-300 hover:scale-105"
                                >
                                  {data?.section4_button_name}
                                </Link>
                              }


                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  }

                  {
                    (data?.section5_status === "Active") && <>
                      <div
                        className="relative flex flex-col lg:flex-row items-center gap-10 p-1 rounded-[32px]"
                      >
                        <div className="absolute inset-0 rounded-[32px] bg-gradient-to-br from-[#00C6FF66] via-[#FF00F733] to-[#00FFAA66] blur-[100px] z-0 opacity-40" />

                        <div className="relative z-10 w-full bg-white/5 backdrop-blur-2xl border border-white/10 rounded-[32px] p-6 md:p-14">
                          <div
                            className={`flex flex-col lg:flex-row items-center gap-10 lg:flex-row-reverse`}
                          >
                            <div className="lg:w-1/2">
                              <img
                                src={IMAGE_URL + data?.section5_image || '/placeholder-image.png'}
                                onError={(e) => {
                                  e.target.src = '/placeholder-image.png'
                                }}
                                className="w-full h-auto rounded-2xl shadow-xl"
                              />
                            </div>

                            <div className="lg:w-1/2 space-y-6">
                              {/* <h2 className="text-[30px] md:text-[50px] leading-[56px] font-extrabold text-white drop-shadow-lg">
                                {data?.section5_heading} <span
                                  className="text-[30px] md:text-[50px] leading-[56px]  font-extrabold bg-gradient-to-r from-[#ffffff] via-[#f55fff] to-[#0047FF] bg-clip-text text-transparent"
                                >
                                  {data?.section5_heading2}
                                </span>
                              </h2> */}
                              <div className=''>
                                <h2 className="text-3xl sm:text-5xl md:text-6xl font-extrabold tracking-tight mb-4 sm:mb-6 leading-tight">
                                  {data?.section5_heading}{" "}
                                  <span className="bg-gradient-to-r from-[#ffffff] via-[#f55fff] to-[#0047FF] bg-clip-text text-transparent drop-shadow-lg">
                                    {data?.section5_heading2}
                                  </span>
                                </h2>
                              </div>


                              <p className="text-gray-300 text-lg">{data.section5_description}</p>
                              {data?.section5_points && (
                                <ul className="space-y-3 pt-2">
                                  {data?.section5_points?.split('|')?.map((item, i) => (
                                    <li
                                      key={i}
                                      className="flex items-start gap-3 text-white text-base"
                                    >
                                      <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#0069ff] bg-opacity-20">
                                        <BsCheckLg className="text-[#00FFD1] text-lg" />
                                      </div>
                                      <span>{item.trim()}</span>
                                    </li>
                                  ))}
                                </ul>
                              )}

                              {
                                data?.section5_button_link &&
                                <Link
                                  to={data?.section5_button_link}
                                  target='_blank'
                                  className="inline-flex items-center gap-2 mt-6 px-6 py-3 text-lg font-semibold bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)] hover:bg-[linear-gradient(45deg,#ff7a18,#ff0066,#9b30ff,#3a7bd5)] text-white rounded-xl shadow-lg transition duration-300 hover:scale-105"
                                >
                                  {data?.section5_button_name}
                                </Link>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  }

                  {
                    (data?.section6_status === "Active") && <>
                      <div
                        className="relative flex flex-col lg:flex-row items-center gap-10 p-1 rounded-[32px]"
                      >
                        <div className="absolute inset-0 rounded-[32px] bg-gradient-to-br from-[#00C6FF66] via-[#FF00F733] to-[#00FFAA66] blur-[100px] z-0 opacity-40" />

                        <div className="relative z-10 w-full bg-white/5 backdrop-blur-2xl border border-white/10 rounded-[32px] p-6 md:p-14">
                          <div
                            className={`flex flex-col lg:flex-row items-center gap-10`}
                          >
                            <div className="lg:w-1/2">
                              <img
                                src={IMAGE_URL + data?.section6_image || '/placeholder-image.png'}
                                onError={(e) => {
                                  e.target.src = '/placeholder-image.png'
                                }}
                                className="w-full h-auto rounded-2xl shadow-xl"
                              />
                            </div>

                            <div className="lg:w-1/2 space-y-6">
                              {/* <h2 className="text-[30px] md:text-[50px] leading-[56px] font-extrabold text-white drop-shadow-lg">
                                {data?.section6_heading} <span
                                  className="text-[30px] md:text-[50px] leading-[56px]  font-extrabold bg-gradient-to-r from-[#ffffff] via-[#f55fff] to-[#0047FF] bg-clip-text text-transparent"
                                >
                                  {data?.section6_heading2}
                                </span>
                              </h2> */}
                              <div className=''>
                                <h2 className="text-3xl sm:text-5xl md:text-6xl font-extrabold tracking-tight mb-4 sm:mb-6 leading-tight">
                                  {data?.section6_heading}{" "}
                                  <span className="bg-gradient-to-r from-[#ffffff] via-[#f55fff] to-[#0047FF] bg-clip-text text-transparent drop-shadow-lg">
                                    {data?.section6_heading2}
                                  </span>
                                </h2>
                              </div>


                              <p className="text-gray-300 text-lg">{data.section6_description}</p>
                              {data?.section6_points && (
                                <ul className="space-y-3 pt-2">
                                  {data?.section6_points?.split('|')?.map((item, i) => (
                                    <li
                                      key={i}
                                      className="flex items-start gap-3 text-white text-base"
                                    >
                                      <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#0069ff] bg-opacity-20">
                                        <BsCheckLg className="text-[#00FFD1] text-lg" />
                                      </div>
                                      <span>{item.trim()}</span>
                                    </li>
                                  ))}
                                </ul>
                              )}

                              {
                                data?.section6_button_link &&
                                <Link
                                  to={data?.section6_button_link}
                                  target='_blank'
                                  className="inline-flex items-center gap-2 mt-6 px-6 py-3 text-lg font-semibold bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)] hover:bg-[linear-gradient(45deg,#ff7a18,#ff0066,#9b30ff,#3a7bd5)] text-white rounded-xl shadow-lg transition duration-300 hover:scale-105"
                                >
                                  {data?.section6_button_name}
                                </Link>
                              }


                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  }
                </div>

              </section>
            </>
          }



          {
            (data?.show_subscription && data?.show_subscription === "Yes") && <>

              {
                (data?.section7_status === "Active") && <>


                  <div className="relative bg-black pb-4 pt-24 overflow-hidden">
                 
                    <div className="pointer-events-none absolute inset-0 z-0">
                      <div className="absolute top-[-200px] left-[-200px] w-[500px] h-[500px] rounded-full bg-[#0026ff] opacity-50 blur-[200px]" />
                      <div className="absolute bottom-[-250px] right-[-150px] w-[600px] h-[600px] rounded-full bg-[#FF00C7] opacity-20 blur-[200px]" />
                      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] rounded-full bg-[#7F00FF] opacity-10 blur-[250px]" />
                    </div>

                    
                    <div className="relative z-10 mx-4">
                      <div className="max-w-[90rem] mx-auto text-center mb-2 px-4">
                        <h2 className="text-4xl md:text-5xl font-extrabold text-white tracking-tight">
                          {data?.section7_heading}{" "}
                          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#ffffff] via-[#f55fff] to-[#0047FF]">
                            {data?.section7_heading2}
                          </span>
                        </h2>
                        <p className="text-gray-400 mt-4 max-w-2xl mx-auto text-lg leading-relaxed">
                          {data?.section7_description}
                        </p>
                      </div>


                      <MembershipCard2/>
                      {/* <div className="flex justify-center mb-10 pt-10">
                        {["Monthly", "Quarterly", "Yearly"].map((type) => (
                          <button
                            key={type}
                            onClick={() => setPlanType(type)}
                            className={`px-4 py-2 mx-2 rounded-lg font-semibold transition flex items-center gap-2 border border-gray-600 ${planType === type
                              ? "bg-gradient-to-r from-[#ffffff] via-[#f55fff] to-[#0047FF] text-white shadow-lg"
                              : "bg-[#2c2c2c] text-white hover:bg-gray-700"
                              }`}
                          >
                            {type}
                          </button>
                        ))}
                      </div>

                      <div className="max-w-[90rem] mx-auto px-4 pb-14 pt-5 grid md:grid-cols-2 lg:grid-cols-3 gap-10 place-items-center">
                        {finalData && finalData?.map((plan, index) => {
                          const priceMap = {
                            Monthly: [
                              plan.monthly_selling_price,
                              plan.monthly_original_price,
                              plan.monthly_discount,
                              plan.monthly_subscription_link,
                              plan.features_heading_monthly,
                            ],
                            Quarterly: [
                              plan.quarterly_selling_price,
                              plan.quarterly_original_price,
                              plan.quarterly_discount,
                              plan.quarterly_subscription_link,
                              plan.features_heading_quarterly,
                            ],
                            Yearly: [
                              plan.yearly_selling_price,
                              plan.yearly_original_price,
                              plan.yearly_discount,
                              plan.yearly_subscription_link,
                              plan.features_heading_yearly,
                            ],
                          };

                          const [selling, original, discount, link, heading] = priceMap[planType];

                          const card = (
                            <div className="relative flex flex-col h-full rounded-2xl p-8 bg-black/40 border border-gray-700 shadow-[0_0_40px_rgba(0,170,255,0.15)] transition-transform hover:scale-[1.02] backdrop-blur-md text-center">
                              <h2 className="text-xl font-bold text-white mb-2">{plan.title}</h2>
                              <p className="text-white mb-4 text-md max-w-[450px] mx-auto">
                                {plan.short_description}
                              </p>

                              <div className="mb-4">
                                <span className="text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-[#ffffff] via-[#f55fff] to-[#0047FF] drop-shadow-md">
                                  ₹{selling} <span className="text-xl text-white">/{planType.slice(0, 2)}</span>
                                </span>
                                <br />
                                <span className="text-xl text-gray-500 line-through">
                                  ₹{original}/{planType.slice(0, 2)}
                                </span>
                              </div>

                              {discount && (
                                <div className="text-sm text-gray-300 font-semibold mb-4">
                                  Save {discount}% by billing {planType}
                                </div>
                              )}

                              <NavLink
                                to={link}
                                target="_blank"
                                className={`block w-full ${plan.isPopular === "Yes"
                                  ? "bg-gradient-to-r from-[#ffffff] via-[#f55fff] to-[#0047FF] hover:opacity-90 border border-customBlue"
                                  : "bg-black/20 border border-customBlue hover:bg-gradient-to-r from-[#ffffff] via-[#f55fff] to-[#0047FF]"
                                  } text-white font-semibold py-4 text-[18px] rounded-md shadow-md transition duration-300`}
                              >
                                {plan.subscription_button_name}
                              </NavLink>

                              <h4 className="text-white text-[20px] mt-8 text-left">{heading}</h4>

                              <ul className="mt-3 space-y-3 text-gray-300 text-sm w-full text-left list-none">
                                {plan.features.map((feature, idx) => (
                                  <li key={idx} className="flex items-center gap-2">
                                    <span className="h-[22px] w-[22px] bg-[#3d3d3d] text-white text-[12px] rounded-full flex items-center justify-center">
                                      <GiCheckMark />
                                    </span>
                                    <span>{feature}</span>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          );

                          return (
                            <div key={index} className="flex flex-col h-full w-full">
                              {plan.isPopular === "Yes" ? (
                                <div className="bg-gradient-to-r from-[#0068FF2e] to-[#00C6FF2e] rounded-2xl p-[2px] h-full flex flex-col">
                                  <div className="text-white text-sm font-bold text-center py-2 rounded-t-2xl bg-black/60">
                                    Most Popular
                                  </div>
                                  <div className="flex-grow flex flex-col rounded-b-2xl">{card}</div>
                                </div>
                              ) : (
                                card
                              )}
                            </div>
                          );
                        })}
                      </div> */}
                    </div>
                  </div>
                </>
              }

            </>
          }

          {
            (data?.section8_status === "Active") && <>
              <section className="bg-black py-20 pt-24 px-4 relative overflow-hidden">
                {/* Glow Effects Background */}
                <div className="pointer-events-none absolute inset-0 z-0">
                  <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[1000px] h-[1000px] rounded-full bg-[#0068FF] opacity-[0.3] blur-[220px]" />
                  <div className="absolute bottom-0 right-0 w-[700px] h-[700px] rounded-full bg-[#f400ffd1] opacity-[0.3] blur-[200px]" />
                </div>

                <div className="relative z-10 max-w-7xl mx-auto text-center">
                  <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4 tracking-tight">
                    {/* What Our{" "} */}
                    {data?.section8_heading} &nbsp;
                    <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#ffffff] via-[#f55fff] to-[#0047FF]">
                      {data?.section8_heading2}
                    </span>
                  </h1>
                  <p className="text-gray-400 max-w-2xl mx-auto text-base md:text-lg mb-12">
                    {/* Hear how creators like you are transforming with our AI-powered training. */}
                    {data?.section8_description}
                  </p>

                  {/* Video Testimonials */}
                  {/* <div className="grid gap-6 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mb-10">
              {videoTestimonials.map((video, index) => (
                <div
                  key={index}
                  className="rounded-2xl overflow-hidden shadow-xl shadow-[#00C6FF]/4 hover:shadow-[#00C6FF]/30 transition-shadow duration-300 border border-white/10 bg-white/5 backdrop-blur-md"
                >
                  <iframe
                    className="w-full aspect-video rounded-xl"
                    src={video.url}
                    title={`Video testimonial ${index + 1}`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                
                </div>
              ))}
            </div> */}
                  <div className="grid gap-6 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mb-10">
                    {additionalData && additionalData?.youtubeData?.map((video, index) => (
                      <div
                        key={index}
                        className="rounded-2xl overflow-hidden shadow-xl shadow-[#00C6FF]/4 hover:shadow-[#00C6FF]/30 transition-shadow duration-300 border border-white/10 bg-white/5 backdrop-blur-md"
                      >
                        <div className="aspect-video w-full rounded-xl overflow-hidden">
                          <ReactPlayer
                            url={video?.youtube_link}
                            width="100%"
                            height="100%"
                            controls
                            className="react-player"
                          />
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Text Testimonials */}
                  <div
                    className={`grid gap-10 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 transition-all duration-500 ease-in-out ${showAll ? "max-h-full" : "max-h-[2400px] overflow-hidden"
                      }`}
                  >
                    {(showAll ? additionalData?.learnersData : additionalData?.learnersData?.slice(0, 6))?.map((t, i) => (
                      <div
                        key={i}
                        className="relative p-6 rounded-2xl bg-white/5 backdrop-blur-md border border-white/10 text-white shadow-xl shadow-[#00C6FF]/3 hover:shadow-[#00C6FF]/30 transition-transform duration-300 hover:scale-[1.02] flex flex-col justify-between"
                      >
                        <div className="text-left mb-4">
                          <FaQuoteLeft className="text-4xl text-[#ff3ff9] drop-shadow-[0_1px_10px_rgba(0,198,255,0.4)]" />
                        </div>
                        <p className="text-left leading-relaxed italic text-white/90 text-sm md:text-base">
                          {t.description}
                        </p>
                        <div className="flex items-center gap-4 pt-6 mt-6 border-t border-white/10">
                          {/* <img
                      src={IMAGE_URL + t.image || '/favicon.png'}
                      onError={(e) => {
                        e.target.src = '/favicon.png'
                      }}
                      alt={t.name}
                      className="w-12 h-12 object-cover rounded-full border border-white/10"
                    /> */}
                          <div className="text-left">
                            <h6 className="font-semibold text-base">{t.name}</h6>
                            <p className="text-sm text-white/70">{t.course}</p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="relative ">
                    {/* Black overlay bar sitting on testimonial grid */}
                    {!showAll && additionalData?.learnersData?.length > 3 && (
                      <div className="absolute bottom-0 left-0 right-0 h-[40rem] bg-gradient-to-t from-black/90 via-black/80 to-transparent z-0 pointer-events-none" />
                    )}

                    {/* Button appears on top of overlay */}
                    <div className="relative z-10 flex justify-center">
                      {
                        (additionalData?.learnersData?.length > 3) &&
                        <button
                          onClick={() => setShowAll(!showAll)}
                          className="block w-auto px-10 text-[18px] py-5 bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)] hover:bg-[linear-gradient(45deg,#ff7a18,#ff0066,#9b30ff,#3a7bd5)] text-white mt-4 border-transparent hover:opacity-90 font-semibold rounded-lg shadow-md transition duration-300"
                        >
                          {showAll ? "Show Less" : "Read More"}
                        </button>
                      }

                    </div>
                  </div>
                </div>
              </section>
            </>
          }



          {
            (data?.section9_status === "Active") && <>
              <div className="bg-[#0d0d0d] pb-14 pt-14 px-4 py-12 pt-24 relative overflow-hidden">
                {/* Soft Background Glow */}
                <div className="pointer-events-none absolute inset-0 z-0">
                  <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[900px] h-[900px] rounded-full bg-[#0014ff] opacity-[0.15] blur-[220px]" />
                  <div className="absolute bottom-0 right-0 w-[600px] h-[600px] rounded-full bg-[#0068FF] opacity-[0.06] blur-[200px]" />
                </div>

                <section className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 md:px-10 text-white">
            <h3 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-center mb-10">
              {data?.section9_heading}{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#ff3ff9] via-[#0068FF] to-[#0047FF]">
                {data?.section9_heading2}
              </span>
            </h3>

            <div className="space-y-4 sm:space-y-5">
              {additionalData?.faqData?.map((faq, index) => {
                const isOpen = openIndex === index;

                return (
                  <div
                    key={index}
                    className={`rounded-2xl border transition-all duration-300
                      ${
                        isOpen
                          ? "bg-gradient-to-r from-[#ff3ff9]/20 via-[#0068FF]/20 to-[#0047FF]/20 border-[#6b9dff] shadow-[0_0_18px_rgba(0,104,255,0.35)]"
                          : "bg-white/10 border-white/30 hover:bg-white/15"
                      }
                    `}
                  >
                    {/* HEADER */}
                    <button
                      onClick={() => toggleFAQ(index)}
                      className="w-full px-5 py-4 flex items-center justify-between text-left rounded-2xl focus:outline-none"
                    >
                      <span className="text-[15px] sm:text-lg font-semibold text-white">
                        {faq.question}
                      </span>

                      <span
                        className={`flex items-center justify-center w-9 h-9 rounded-full transition-all duration-300
                          ${
                            isOpen
                              ? "rotate-180 bg-[#0068FF]/30 text-white"
                              : "bg-white/20 text-white"
                          }
                        `}
                      >
                        <IoChevronDownSharp className="text-xl" />
                      </span>
                    </button>

                    {/* CONTENT */}
                    <div
                      className={`overflow-hidden transition-all duration-300 px-5
                        ${isOpen ? "max-h-[500px] pb-5" : "max-h-0"}
                      `}
                    >
                      {isOpen && (
                        <div className="pt-1 text-sm sm:text-base text-white/80 leading-relaxed whitespace-pre-line">
                          {faq.answer}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </section>

              </div>
            </>
          }

           <section className="relative relative pt-12 pb-10 sm:pt-16 sm:pb-14 bg-gradient-to-br from-[#0f0f0f] via-black to-[#1a1a1a] py-12 sm:py-16 overflow-hidden">
             <div className="max-w-[80rem] mx-auto px-5 relative">
               <div className="rounded-2xl border border-blue-700">
                 <div
                   className="relative z-10 text-white rounded-2xl shadow-2xl backdrop-blur-md overflow-hidden"
                   style={{
                     backgroundImage:
                       "linear-gradient(rgba(0, 2, 69, 0.69), rgba(0, 16, 53, 0.43), rgba(36, 1, 78, 0.23), rgba(0, 44, 201, 0.31)), url('/bg-g.svg')",
                     backgroundPosition: "center center",
                     backgroundRepeat: "no-repeat",
                     backgroundSize: "cover",
                   }}
                 >
                   {/* GRID */}
                   <div className="relative z-10 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 items-start md:items-center">
           
                     {/* LEFT IMAGE */}
                     <div className="flex justify-center md:justify-start">
                       <img
                         src="https://tagmango.com/publicassets/-all-in-one--combo-10-ai-courses-840fb11c320a44c311b84ee74c4d7d78.png"
                         alt="10-in-1 AI Combo"
                         className="w-full max-w-[420px] md:max-w-[480px] drop-shadow-2xl"
                         
                       />
                     </div>
           
                     {/* RIGHT CONTENT */}
                     <div className="
                  text-center md:text-left
                  px-4 sm:px-6 md:px-0
                  pb-6 sm:pb-8 md:pb-0
                ">
                  <h2 className="
                  text-[18px] sm:text-[38px]
                  font-extrabold text-white mb-3
                  flex items-center justify-center md:justify-start gap-2
                  whitespace-nowrap
                ">
                  <FaBolt className="text-white animate-pulse shrink-0" />
                  <span className="truncate">
                    10-in-1 AI Viral Course Pack
                  </span>
                </h2>


                  <p className="text-gray-300 max-w-xl mb-5 sm:mb-6 text-sm sm:text-base">
                    Learn to master AI tools, create viral content, and grow your
                    digital presence — all in one power-packed combo course!
                  </p>

                  <a
                    target="_blank"
                    href="https://learn.nextfutureai.in/web/checkout/694cd30d8be865fb77780ab3?couponcode=(COMBO10)&purchaseNow=true"
                    className="
                      inline-flex items-center justify-center gap-2
                      px-6 sm:px-7
                      py-3
                      rounded-lg font-semibold text-white text-sm
                      bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)]
                      hover:bg-[linear-gradient(45deg,#ff7a18,#ff0066,#9b30ff,#3a7bd5)]
                      transition-all duration-300 shadow-lg
                    "
                  >
                    <FaGift className="text-yellow-300" />
                    GRAB OFFER
                  </a>

                  <p className="mt-4 text-sm sm:text-base text-gray-300">
                    Get <span className="text-yellow-400 font-bold">20% Off</span> Available
                  </p>
                </div>

           
                   </div>
                 </div>
               </div>
             </div>
           </section>






          <CallToAction />
        </div>

      </div>
      <Footer />
      <MobileFooter />
    </div>
  );
};

export default Home2;
